(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 15597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/hackathon2021",
      function () {
        return __webpack_require__(11192);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 11192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/image/index.js + 22 modules
var es_image = __webpack_require__(44458);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
// EXTERNAL MODULE: ./src/utils/link.utils.js
var link_utils = __webpack_require__(2428);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/ball.png
/* harmony default export */ var ball = ({"src":"https://img1.tidb.net/_next/static/media/ball.8d8bb413.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEVwhfR6xPh8zPlvg/RpXvFvgPNMaXFxkvWB6/t4tveB6vtxj/V5vPd80PlzmfV91vngo/9PAAAAEHRSTlMdGiYpNhcAEDU1SDljhE1QmiLd/AAAAAlwSFlzAABb9wAAW/cB+DQ0YwAAADpJREFUCJlFyLkRwDAMAzBS1GPJdvYfN5cqHQ5InvPsSPDeljww0ybIMWYE4Fg/SIQcXN94Ict6q/IFL00BJqmJepcAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/banner-title.svg
var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBannerTitle = function SvgBannerTitle(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 740 157.729"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__a",
    x1: 0.5,
    y1: -0.041,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__b",
    x1: 0.5,
    y1: -0.026,
    x2: 0.5,
    y2: 0.911,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__c",
    x1: 0.5,
    y1: -0.006,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__d",
    x1: 0.5,
    y1: 0.092,
    x2: 0.5,
    y2: 0.836,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__e",
    x1: 0.5,
    y1: -0.005,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__f",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.814,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__g",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.813,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__h",
    x1: 0.5,
    y1: 0.061,
    x2: 0.5,
    y2: 0.842,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__i",
    x1: 0.5,
    y1: 0.058,
    x2: 0.5,
    y2: 0.832,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__j",
    x1: 0.5,
    y1: 0.041,
    x2: 0.5,
    y2: 0.827,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__k",
    x1: 0.5,
    y1: -0.252,
    x2: 0.5,
    y2: 0.884,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__l",
    x1: 0.5,
    y1: -0.147,
    x2: 0.5,
    y2: 0.894,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__m",
    x1: 0.5,
    y1: -0.084,
    x2: 0.5,
    y2: 0.816,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__n",
    x1: 0.5,
    y1: -0.03,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__o",
    x1: 0.5,
    y1: -0.108,
    x2: 0.5,
    y2: 0.817,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__p",
    x1: 0.5,
    y1: -0.031,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__q",
    x1: 0.5,
    y1: -0.039,
    x2: 0.5,
    y2: 0.828,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__r",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.799,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__s",
    x1: 0.5,
    y1: -0.188,
    x2: 0.5,
    y2: 0.9,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__t",
    x1: 0.5,
    y1: -0.189,
    x2: 0.5,
    y2: 0.89,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__u",
    x1: 0.5,
    y1: -0.207,
    x2: 0.5,
    y2: 0.888,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__v",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__w",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__x",
    x1: 0.5,
    y1: -0.184,
    x2: 0.5,
    y2: 0.889,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title_svg__y",
    x1: 0.5,
    y1: -6.075,
    x2: 0.5,
    y2: 4.212,
    xlinkHref: "#banner-title_svg__a"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7668"
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7660"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19064",
    d: "M134.03 213.318v11.659h18.8v10.838h-18.8v12.645h21.265v11.249h-35.3v-57.64h35.3v11.249Z",
    transform: "translate(-119.99 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19065",
    d: "m202.44 259.708-11.74-17.653-10.344 17.653h-15.932L182.9 230.4l-18.885-28.327h16.34l11.576 17.407 10.181-17.407h15.928l-18.31 29.062 19.048 28.573Z",
    transform: "translate(-119.925 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19066",
    d: "M270.162 229.78a16.9 16.9 0 0 1-7.06 6.692 24.856 24.856 0 0 1-11.823 2.545h-8.7v20.691h-14.044v-57.639h22.743a25.886 25.886 0 0 1 11.659 2.382 16.371 16.371 0 0 1 7.143 6.569 19.091 19.091 0 0 1 2.382 9.606 18.561 18.561 0 0 1-2.3 9.154Zm-13.962-3.818a8.211 8.211 0 0 0 0-10.674q-1.971-1.888-5.994-1.889h-7.635v14.451h7.635q4.028.001 5.994-1.888Z",
    transform: "translate(-119.83 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19067",
    d: "M296.52 248.87h18.392v10.838h-32.431v-57.639h14.039Z",
    transform: "translate(-119.751 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19068",
    d: "M336.734 256.506a28.222 28.222 0 0 1-10.756-10.55 31.04 31.04 0 0 1 0-30.42 28.33 28.33 0 0 1 10.756-10.509 31.289 31.289 0 0 1 29.8 0 27.741 27.741 0 0 1 10.674 10.509 31.466 31.466 0 0 1-.041 30.42 28.023 28.023 0 0 1-10.674 10.55 31.208 31.208 0 0 1-29.763 0Zm25.945-13.629q4.145-4.6 4.146-12.152 0-7.636-4.146-12.193a14.209 14.209 0 0 0-11.043-4.557q-6.979 0-11.125 4.516t-4.146 12.234q0 7.636 4.146 12.193t11.125 4.557a14.142 14.142 0 0 0 11.043-4.598Z",
    transform: "translate(-119.692 -148.678)",
    fill: "url(#banner-title_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19069",
    d: "m420.993 259.708-11.986-21.758h-3.367v21.758H391.6v-57.639h23.564a25.943 25.943 0 0 1 11.618 2.382 16.417 16.417 0 0 1 7.184 6.528 18.214 18.214 0 0 1 2.381 9.237 17.157 17.157 0 0 1-3.243 10.263 17.456 17.456 0 0 1-9.565 6.4l13.3 22.826Zm-15.353-31.693h8.7q3.858 0 5.787-1.889a7.13 7.13 0 0 0 1.93-5.337 6.909 6.909 0 0 0-1.93-5.173q-1.93-1.888-5.787-1.889h-8.7Z",
    transform: "translate(-119.59 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19070",
    d: "M461.88 213.318v11.659h18.8v10.838h-18.8v12.645h21.266v11.249h-35.3v-57.64h35.3v11.249Z",
    transform: "translate(-119.507 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19071",
    d: "M556.615 202.069v11.249h-15.27v46.39H527.3v-46.39h-15.268v-11.249Z",
    transform: "translate(-119.413 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19072",
    d: "M616.306 202.069v57.639h-14.04v-23.729h-21.84v23.729h-14.04v-57.639h14.04v22.579h21.84v-22.579Z",
    transform: "translate(-119.333 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19073",
    d: "M643.143 213.318v11.659h18.8v10.838h-18.8v12.645h21.266v11.249H629.1v-57.64h35.3v11.249Z",
    transform: "translate(-119.24 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19074",
    d: "M705.937 258.231a18.461 18.461 0 0 1-8.006-6.076 16.586 16.586 0 0 1-3.161-9.688h14.944a7.237 7.237 0 0 0 2.216 4.885 7.122 7.122 0 0 0 4.926 1.683 7.7 7.7 0 0 0 4.926-1.437 4.809 4.809 0 0 0 1.807-3.982 4.718 4.718 0 0 0-1.437-3.531 11.621 11.621 0 0 0-3.53-2.3 57.074 57.074 0 0 0-5.954-2.053 64.784 64.784 0 0 1-9.113-3.448 16.831 16.831 0 0 1-6.076-5.09 14.18 14.18 0 0 1-2.545-8.786q0-8.046 5.83-12.6t15.189-4.557q9.524 0 15.354 4.557t6.24 12.685h-15.188a5.946 5.946 0 0 0-2.053-4.392 7.231 7.231 0 0 0-4.844-1.6 6.037 6.037 0 0 0-4.105 1.354 4.887 4.887 0 0 0-1.56 3.9 4.833 4.833 0 0 0 2.628 4.351 42.9 42.9 0 0 0 8.21 3.366 76.253 76.253 0 0 1 9.073 3.613 17.276 17.276 0 0 1 6.034 5.008 13.406 13.406 0 0 1 2.545 8.456 16.592 16.592 0 0 1-2.5 8.949 17.54 17.54 0 0 1-7.267 6.4 24.862 24.862 0 0 1-11.249 2.381 29.628 29.628 0 0 1-11.334-2.048Z",
    transform: "translate(-119.144 -148.678)",
    fill: "url(#banner-title_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19075",
    d: "m783.034 259.708-19.378-25.453v25.453h-14.038v-57.639h14.039v25.289l19.213-25.289h16.5l-22.33 28.245 23.154 29.394Z",
    transform: "translate(-119.063 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19076",
    d: "m858.981 202.069-19.951 38.59v19.049h-14.041v-19.049l-19.951-38.59h15.928l11.166 24.139 11.084-24.139Z",
    transform: "translate(-118.981 -148.677)",
    fill: "url(#banner-title_svg__a)"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7661"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19077",
    d: "M132.349 288.388v2.371h-4.714V306.1h-2.906v-15.341h-4.739v-2.371Z",
    transform: "translate(-119.99 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19078",
    d: "M159.84 289.666a1.86 1.86 0 0 1 1.325-3.186 1.77 1.77 0 0 1 1.3.535 1.91 1.91 0 0 1 0 2.651 1.77 1.77 0 0 1-1.3.535 1.8 1.8 0 0 1-1.325-.535Zm2.752 2.4V306.1h-2.905v-14.039Z",
    transform: "translate(-119.932 -148.552)",
    fill: "url(#banner-title_svg__d)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19079",
    d: "M201.574 289.472a7.753 7.753 0 0 1 3.288 3.11 9.348 9.348 0 0 1 1.16 4.727 9.142 9.142 0 0 1-1.16 4.689 7.657 7.657 0 0 1-3.288 3.045 11 11 0 0 1-4.956 1.058h-5.784v-17.713h5.784a10.784 10.784 0 0 1 4.956 1.084Zm-.191 12.577a6.468 6.468 0 0 0 1.656-4.74 6.683 6.683 0 0 0-1.656-4.816 6.283 6.283 0 0 0-4.765-1.734h-2.88v12.972h2.88a6.4 6.4 0 0 0 4.765-1.683Z",
    transform: "translate(-119.886 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19080",
    d: "M245.2 298.5a4.549 4.549 0 0 1 .292 5.264 4.755 4.755 0 0 1-2.026 1.707 7.169 7.169 0 0 1-3.084.624H233.3v-17.707h6.753a7.231 7.231 0 0 1 3.109.613 4.569 4.569 0 0 1 1.963 1.642 4.183 4.183 0 0 1 .662 2.307 3.958 3.958 0 0 1-.814 2.549 4.756 4.756 0 0 1-2.192 1.5 3.926 3.926 0 0 1 2.419 1.501Zm-9-2.675h3.6a3.449 3.449 0 0 0 2.229-.65 2.267 2.267 0 0 0 .8-1.873 2.315 2.315 0 0 0-.8-1.874 3.364 3.364 0 0 0-2.229-.675h-3.593Zm6.243 7.187a2.466 2.466 0 0 0 .841-1.988 2.578 2.578 0 0 0-.892-2.064 3.517 3.517 0 0 0-2.369-.764H236.2v5.53h3.924a3.474 3.474 0 0 0 2.327-.709Z",
    transform: "translate(-119.823 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19081",
    d: "M318.951 288.388V306.1h-2.9v-7.747h-8.334v7.747h-2.9v-17.712h2.9v7.6h8.334v-7.6Z",
    transform: "translate(-119.718 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19082",
    d: "M357.855 302.482h-7.416l-1.275 3.618h-3.032l6.345-17.737h3.364l6.345 17.737h-3.057Zm-.816-2.371-2.879-8.232-2.905 8.232Z",
    transform: "translate(-119.657 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19083",
    d: "M389.584 292.543a8.623 8.623 0 0 1 3.288-3.225 9.67 9.67 0 0 1 9.582.229 7.912 7.912 0 0 1 3.2 3.938h-3.494a4.682 4.682 0 0 0-1.911-2.09 5.674 5.674 0 0 0-2.829-.687 6.182 6.182 0 0 0-3.135.789 5.5 5.5 0 0 0-2.153 2.268 8 8 0 0 0 0 6.88 5.585 5.585 0 0 0 2.153 2.281 6.11 6.11 0 0 0 3.135.8 5.675 5.675 0 0 0 2.829-.689 4.68 4.68 0 0 0 1.911-2.089h3.491a7.835 7.835 0 0 1-3.2 3.924 9.306 9.306 0 0 1-5.033 1.376 9.153 9.153 0 0 1-4.562-1.159 8.657 8.657 0 0 1-3.275-3.224 9.586 9.586 0 0 1 0-9.327Z",
    transform: "translate(-119.595 -148.55)",
    fill: "url(#banner-title_svg__f)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19084",
    d: "m443.2 306.1-6.855-7.926v7.926h-2.905v-17.712h2.905v8.079l6.881-8.079h3.644l-7.7 8.869L447 306.1Z",
    transform: "translate(-119.528 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19085",
    d: "M484.655 302.482h-7.416l-1.275 3.618h-3.032l6.345-17.737h3.365l6.345 17.737h-3.059Zm-.816-2.371-2.879-8.232-2.905 8.232Z",
    transform: "translate(-119.47 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19086",
    d: "M527.584 288.388v2.371h-4.715V306.1h-2.905v-15.341h-4.74v-2.371Z",
    transform: "translate(-119.408 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19087",
    d: "M569.065 288.388V306.1h-2.905v-7.747h-8.333v7.747h-2.905v-17.712h2.905v7.6h8.333v-7.6Z",
    transform: "translate(-119.35 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19088",
    d: "M600.82 305.119a8.6 8.6 0 0 1-3.287-3.237 9.609 9.609 0 0 1 0-9.339 8.627 8.627 0 0 1 3.287-3.225 9.559 9.559 0 0 1 9.123 0 8.526 8.526 0 0 1 3.275 3.225 9.7 9.7 0 0 1 0 9.339 8.5 8.5 0 0 1-3.275 3.237 9.552 9.552 0 0 1-9.123 0Zm7.684-2.165a5.571 5.571 0 0 0 2.153-2.294 7.372 7.372 0 0 0 .777-3.453 7.293 7.293 0 0 0-.777-3.44 5.5 5.5 0 0 0-2.157-2.267 6.62 6.62 0 0 0-6.269 0 5.491 5.491 0 0 0-2.153 2.268 7.28 7.28 0 0 0-.778 3.44 7.359 7.359 0 0 0 .778 3.453 5.559 5.559 0 0 0 2.153 2.294 6.525 6.525 0 0 0 6.269 0Z",
    transform: "translate(-119.289 -148.55)",
    fill: "url(#banner-title_svg__g)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19089",
    d: "M656.219 306.1h-2.905l-8.741-13.225V306.1h-2.905v-17.737h2.905l8.741 13.2v-13.2h2.905Z",
    transform: "translate(-119.222 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19090",
    d: "M716.712 302.152q2.447-2.115 3.862-3.479a15.682 15.682 0 0 0 2.357-2.841 5.464 5.464 0 0 0 .942-2.955 3.622 3.622 0 0 0-.726-2.4 2.815 2.815 0 0 0-2.28-.866 2.92 2.92 0 0 0-2.332.955 3.976 3.976 0 0 0-.879 2.561h-2.8a6.24 6.24 0 0 1 10.334-4.459 5.435 5.435 0 0 1 1.567 4.077 7.24 7.24 0 0 1-.93 3.529 14.252 14.252 0 0 1-2.217 3.032q-1.288 1.339-3.275 3.1l-1.147 1.02h8.078v2.421h-12.389v-2.114Z",
    transform: "translate(-119.114 -148.551)",
    fill: "url(#banner-title_svg__h)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19091",
    d: "M755.708 289.677q1.492-2.485 5.136-2.485t5.135 2.485a13.417 13.417 0 0 1 1.491 6.894 13.675 13.675 0 0 1-1.491 6.969q-1.49 2.51-5.135 2.511t-5.136-2.511a13.686 13.686 0 0 1-1.49-6.969 13.428 13.428 0 0 1 1.49-6.894Zm8.64 3.4a4.681 4.681 0 0 0-1.084-2.331 3.69 3.69 0 0 0-4.842 0 4.68 4.68 0 0 0-1.083 2.331 19.332 19.332 0 0 0-.267 3.491 21.241 21.241 0 0 0 .254 3.593 4.493 4.493 0 0 0 1.083 2.344 3.766 3.766 0 0 0 4.868 0 4.494 4.494 0 0 0 1.083-2.344 21.23 21.23 0 0 0 .255-3.593 19.333 19.333 0 0 0-.267-3.488Z",
    transform: "translate(-119.056 -148.551)",
    fill: "url(#banner-title_svg__i)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19092",
    d: "M796.563 302.152q2.447-2.115 3.862-3.479a15.644 15.644 0 0 0 2.357-2.841 5.465 5.465 0 0 0 .942-2.955 3.622 3.622 0 0 0-.726-2.4 2.813 2.813 0 0 0-2.28-.866 2.92 2.92 0 0 0-2.332.955 3.976 3.976 0 0 0-.879 2.561h-2.8a6.24 6.24 0 0 1 10.334-4.459 5.434 5.434 0 0 1 1.567 4.077 7.242 7.242 0 0 1-.93 3.529 14.221 14.221 0 0 1-2.217 3.032q-1.287 1.339-3.275 3.1l-1.147 1.02h8.079v2.421h-12.389v-2.114Z",
    transform: "translate(-118.996 -148.551)",
    fill: "url(#banner-title_svg__h)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19093",
    d: "M833.687 290.174v-2.651h5.3V306.1h-2.931v-15.926Z",
    transform: "translate(-118.939 -148.55)",
    fill: "url(#banner-title_svg__j)"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7662"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19094",
    d: "M131.69 153.149v1.779h-4.567V169.9h-2.187v-14.972h-4.591v-1.779Z",
    transform: "translate(-119.989 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19095",
    d: "M144.321 154.161a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.021.433 1.54 1.54 0 0 1 0 2.115 1.371 1.371 0 0 1-1.021.433 1.438 1.438 0 0 1-1.058-.433Zm2.116 2.571V169.9h-2.188v-13.168Z",
    transform: "translate(-119.954 -148.751)",
    fill: "url(#banner-title_svg__l)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19096",
    d: "M170 154.171a7.179 7.179 0 0 1 3.077 2.92 9.853 9.853 0 0 1 0 8.929A7.054 7.054 0 0 1 170 168.9a10.552 10.552 0 0 1-4.747 1h-5.213v-16.751h5.216a10.343 10.343 0 0 1 4.744 1.022Zm.2 12.21a6.542 6.542 0 0 0 1.707-4.819 6.676 6.676 0 0 0-1.719-4.88 6.608 6.608 0 0 0-4.939-1.754h-3.027V168.1h3.027a6.678 6.678 0 0 0 4.958-1.72Z",
    transform: "translate(-119.931 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19097",
    d: "M196.955 162.018a4.372 4.372 0 0 1 1.2 1.49 4.333 4.333 0 0 1-.2 4.193 4.41 4.41 0 0 1-1.887 1.611 6.742 6.742 0 0 1-2.92.589H186.9v-16.752h6a6.8 6.8 0 0 1 2.908.565 4.116 4.116 0 0 1 1.8 1.526 4 4 0 0 1 .6 2.162 3.737 3.737 0 0 1-.805 2.465 4.514 4.514 0 0 1-2.127 1.405 3.551 3.551 0 0 1 1.679.746Zm-7.872-1.634h3.677a3.552 3.552 0 0 0 2.38-.721 2.786 2.786 0 0 0 0-3.99 3.625 3.625 0 0 0-2.428-.721h-3.629Zm6.417 6.945a2.641 2.641 0 0 0 .913-2.138 2.72 2.72 0 0 0-.961-2.2 3.883 3.883 0 0 0-2.572-.8h-3.8v5.909h3.87a3.836 3.836 0 0 0 2.55-.771Z",
    transform: "translate(-119.891 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19098",
    d: "M247.552 166.108h-21.224v-1.586h9.686v-2.164H228.3v-1.466h7.715v-1.972h-7.307v-8.22h16.369v8.221h-7.307v1.971h7.763v1.466h-7.763v2.164h9.782Zm-21.2 4.951a10.683 10.683 0 0 0 2.669-3.99l1.707.409a12.568 12.568 0 0 1-2.716 4.374Zm9.663-13.654v-5.191h-5.6v5.186Zm-3.077-4.591a12.562 12.562 0 0 1 1.562 3.509l-1.25.482a14.411 14.411 0 0 0-1.49-3.582Zm1.827 14.735a18.37 18.37 0 0 1 .529 3.823l-1.755.24a22.865 22.865 0 0 0-.433-3.943Zm8.534-15.335h-5.529v5.186h5.53Zm-3.605 15.166a22.323 22.323 0 0 1 1.37 3.8l-1.755.433a28.01 28.01 0 0 0-1.274-3.895Zm-.841-10.792a25.157 25.157 0 0 0 1.851-3.8l1.394.529c-.673 1.3-1.466 2.788-2.091 3.75Zm5.648 10.48a22.748 22.748 0 0 1 3.174 4.038l-1.732.673a24.265 24.265 0 0 0-3.052-4.159Z",
    transform: "translate(-119.833 -148.752)",
    fill: "url(#banner-title_svg__m)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19099",
    d: "M277.379 156.493a16.488 16.488 0 0 1-4.783 4.592 31.611 31.611 0 0 0 9.3 2.548 7.913 7.913 0 0 0-1.13 1.683 25.841 25.841 0 0 1-3.342-.674v7.066h-1.8v-.768h-9.494v.793h-1.73v-6.971c-1.274.386-2.548.673-3.8.937a6.65 6.65 0 0 0-.865-1.562 35.817 35.817 0 0 0 9.447-3 17.688 17.688 0 0 1-3.15-2.764 21.68 21.68 0 0 1-3.75 2.331 5.491 5.491 0 0 0-1.2-1.274 16.032 16.032 0 0 0 6.826-5.385l1.924.337c-.336.48-.721.936-1.106 1.418h7.138l.312-.072Zm-14.9-.023h-1.755v-4.52h9.567c-.338-.625-.721-1.346-1.082-1.923l1.731-.434a23.439 23.439 0 0 1 1.394 2.356h8.558v4.52h-1.8v-2.861h-16.61Zm14.038 7.933a29.2 29.2 0 0 1-5.672-2.284 31.341 31.341 0 0 1-5.361 2.284Zm-.889 5v-3.486h-9.498v3.483Zm-8.341-12.091a15.136 15.136 0 0 0 3.582 2.908 16.769 16.769 0 0 0 3.774-3h-7.263Z",
    transform: "translate(-119.784 -148.754)",
    fill: "url(#banner-title_svg__n)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19100",
    d: "M309.728 166.755h-15.576v-1.707h15.576Zm4.951-6.3s-.024.577-.072.841c-.553 6.249-1.082 8.726-2.019 9.639a2.511 2.511 0 0 1-1.923.768 34.218 34.218 0 0 1-3.775-.047 4.156 4.156 0 0 0-.552-1.731c1.538.144 3.077.168 3.677.168a1.506 1.506 0 0 0 1.058-.265c.7-.625 1.2-2.74 1.682-7.715h-15.334c.288-1.924.6-5.048.769-7.38l1.755.12a209.76 209.76 0 0 1-.553 5.6h9.327c.312-2.429.625-5.36.841-7.476h-13.581v-1.731h13.893l.288-.1 1.3.145c-.192 2.523-.577 6.177-.961 9.157Z",
    transform: "translate(-119.733 -148.751)",
    fill: "url(#banner-title_svg__o)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19101",
    d: "M335.444 162c-.937.288-1.852.577-2.765.841v6.851c0 .985-.216 1.418-.817 1.707a6.894 6.894 0 0 1-2.932.311 7.424 7.424 0 0 0-.529-1.609c.961.024 1.875.024 2.115 0 .312 0 .433-.1.433-.434v-6.321l-2.764.817-.5-1.731c.913-.216 2.043-.529 3.269-.865V156.3h-2.956v-1.659h2.956v-4.831h1.731v4.831h2.515v1.659h-2.524v4.807l2.548-.746Zm14.253 7.042v1.708h-14.614v-1.708h8.125a93.194 93.194 0 0 0 2.259-11.9l1.9.336c-.649 3.7-1.61 8.388-2.5 11.561Zm-.625-13.22h-12.858v-1.681h12.859Zm-9.59 12.116a91.481 91.481 0 0 0-1.635-10.241l1.562-.336a90.464 90.464 0 0 1 1.8 10.072Zm2.307-14.063a26.87 26.87 0 0 0-1.154-3.822l1.682-.433a31.358 31.358 0 0 1 1.2 3.726Z",
    transform: "translate(-119.684 -148.754)",
    fill: "url(#banner-title_svg__p)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19102",
    d: "M369.067 163.7c-.385-.889-1.25-2.476-2.019-3.8v11.827h-1.755v-11.25a26.989 26.989 0 0 1-3 6.85 10.287 10.287 0 0 0-.986-1.73 25.144 25.144 0 0 0 3.8-9.062h-3.438v-1.683h3.63v-5.071h1.755v5.071h2.98v1.683h-2.98v.961c.817 1.082 2.812 4.014 3.245 4.735Zm6.274-12.788a25.569 25.569 0 0 1-4.159 9.734 13.72 13.72 0 0 0-1.562-1.057 20.622 20.622 0 0 0 3.895-8.99Zm4.23 12.475a44.672 44.672 0 0 1 3.341 7.091l-1.634.768a16.918 16.918 0 0 0-.649-1.8c-8 1.057-9.062 1.226-9.735 1.562h-.024v-.1c-.144-.41-.433-1.226-.649-1.708.529-.143.985-.936 1.562-2.115a51.4 51.4 0 0 0 3.582-9.614l1.851.7a62.328 62.328 0 0 1-4.255 10.553l7.043-.842c-.6-1.321-1.25-2.691-1.9-3.87Zm-.264-13.052a23.518 23.518 0 0 0 4.062 8.8 5.874 5.874 0 0 0-1.418 1.466 27.656 27.656 0 0 1-4.326-9.88Z",
    transform: "translate(-119.634 -148.753)",
    fill: "url(#banner-title_svg__q)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19103",
    d: "M422.122 148.755v24.037h-1.009v-24.037Z",
    transform: "translate(-119.546 -148.755)",
    fill: "url(#banner-title_svg__r)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19104",
    d: "M464.774 164.122a19.371 19.371 0 0 0 2.921-3.292 5.931 5.931 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.7 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.569v-1.561q3.051-2.446 4.782-4.024Z",
    transform: "translate(-119.489 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19105",
    d: "M485.29 154.58q1.346-2.319 4.711-2.32 3.339 0 4.686 2.32a12.919 12.919 0 0 1 1.347 6.452 13.169 13.169 0 0 1-1.347 6.539Q493.341 169.9 490 169.9q-3.366 0-4.711-2.331a13.159 13.159 0 0 1-1.347-6.539 12.908 12.908 0 0 1 1.348-6.45Zm8.3 2.907a4.528 4.528 0 0 0-1.13-2.343 3.9 3.9 0 0 0-4.952 0 4.513 4.513 0 0 0-1.13 2.343 19.361 19.361 0 0 0-.276 3.545 20.017 20.017 0 0 0 .276 3.629 4.518 4.518 0 0 0 1.13 2.356 3.892 3.892 0 0 0 4.952 0 4.533 4.533 0 0 0 1.13-2.356 20.116 20.116 0 0 0 .275-3.629 19.457 19.457 0 0 0-.271-3.544Z",
    transform: "translate(-119.454 -148.75)",
    fill: "url(#banner-title_svg__t)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19106",
    d: "M513.422 164.122a19.362 19.362 0 0 0 2.92-3.292 5.932 5.932 0 0 0 1.19-3.377 3.711 3.711 0 0 0-.757-2.464 3.016 3.016 0 0 0-2.439-.9 3.206 3.206 0 0 0-2.536 1.02 4.264 4.264 0 0 0-.973 2.729h-2.115a5.778 5.778 0 0 1 1.634-4.159 6.207 6.207 0 0 1 7.9-.1 4.933 4.933 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.7 3.318q-1.514 1.43-3.87 3.329h8.26v1.826h-11.561v-1.561q3.053-2.446 4.783-4.024Z",
    transform: "translate(-119.417 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19107",
    d: "M532.015 154.519v-1.994h4.519V169.9h-2.211v-15.381Z",
    transform: "translate(-119.383 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19108",
    d: "M550.16 169.593a1.49 1.49 0 0 1 1.058-2.548 1.37 1.37 0 0 1 1.021.432 1.541 1.541 0 0 1 0 2.116 1.37 1.37 0 0 1-1.021.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-119.357 -148.728)",
    fill: "url(#banner-title_svg__v)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19109",
    d: "M564.511 154.519v-1.994h4.518V169.9h-2.211v-15.381Z",
    transform: "translate(-119.335 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19110",
    d: "M587.173 164.122a19.36 19.36 0 0 0 2.92-3.292 5.931 5.931 0 0 0 1.19-3.377 3.717 3.717 0 0 0-.756-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.257 4.257 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.206 6.206 0 0 1 7.895-.1 4.934 4.934 0 0 1 1.455 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.267v1.826h-11.56v-1.561q3.052-2.446 4.783-4.024Z",
    transform: "translate(-119.309 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19111",
    d: "M606.343 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.021.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.021.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-119.274 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19112",
    d: "M625.2 167.355a3.537 3.537 0 0 0 2.367.745 3.2 3.2 0 0 0 2.944-1.563q.949-1.561.9-5.264a3.629 3.629 0 0 1-1.682 1.7 5.588 5.588 0 0 1-2.62.613 6.109 6.109 0 0 1-2.872-.661 4.8 4.8 0 0 1-1.983-1.936 6.148 6.148 0 0 1-.721-3.076 5.786 5.786 0 0 1 1.49-4.147 5.549 5.549 0 0 1 4.23-1.574q3.365 0 4.723 2.188t1.358 6.514a19.311 19.311 0 0 1-.541 5 5.627 5.627 0 0 1-1.827 3 5.475 5.475 0 0 1-3.521 1.034 5.276 5.276 0 0 1-3.822-1.322 5.186 5.186 0 0 1-1.562-3.366h2.019a3.444 3.444 0 0 0 1.12 2.115Zm4.915-6.623a3.58 3.58 0 0 0 1.034-2.7 4.144 4.144 0 0 0-1.01-2.907 3.647 3.647 0 0 0-2.836-1.107 3.509 3.509 0 0 0-2.68 1.059 3.9 3.9 0 0 0-1 2.787 3.961 3.961 0 0 0 .985 2.813 3.719 3.719 0 0 0 2.86 1.058 3.647 3.647 0 0 0 2.647-1.002Z",
    transform: "translate(-119.251 -148.75)",
    fill: "url(#banner-title_svg__x)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19113",
    d: "M672.068 160.157v1.851h-9.59v-1.851Z",
    transform: "translate(-119.191 -148.738)",
    fill: "url(#banner-title_svg__y)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19114",
    d: "M706.5 164.122a19.406 19.406 0 0 0 2.92-3.292 5.931 5.931 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.209 3.209 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.188 7.188 0 0 1-1.19 3.882 17.03 17.03 0 0 1-2.7 3.318q-1.514 1.43-3.87 3.329h8.268v1.826h-11.567v-1.561q3.051-2.446 4.782-4.024Z",
    transform: "translate(-119.133 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19115",
    d: "M727.016 154.58q1.346-2.319 4.711-2.32 3.339 0 4.686 2.32a12.919 12.919 0 0 1 1.347 6.452 13.169 13.169 0 0 1-1.347 6.539q-1.346 2.331-4.686 2.331-3.366 0-4.711-2.331a13.159 13.159 0 0 1-1.347-6.539 12.908 12.908 0 0 1 1.347-6.452Zm8.3 2.907a4.512 4.512 0 0 0-1.13-2.343 3.9 3.9 0 0 0-4.952 0 4.513 4.513 0 0 0-1.13 2.343 19.377 19.377 0 0 0-.275 3.545 20.033 20.033 0 0 0 .275 3.629 4.519 4.519 0 0 0 1.13 2.356 3.892 3.892 0 0 0 4.952 0 4.518 4.518 0 0 0 1.13-2.356 20.121 20.121 0 0 0 .275-3.629 19.463 19.463 0 0 0-.271-3.544Z",
    transform: "translate(-119.098 -148.75)",
    fill: "url(#banner-title_svg__t)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19116",
    d: "M755.149 164.122a19.409 19.409 0 0 0 2.92-3.292 5.932 5.932 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.209 3.209 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.936 4.936 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.564v-1.561q3.051-2.446 4.783-4.024Z",
    transform: "translate(-119.061 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19117",
    d: "M778.837 164.122a19.406 19.406 0 0 0 2.92-3.292 5.93 5.93 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.564v-1.561q3.051-2.446 4.783-4.024Z",
    transform: "translate(-119.026 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19118",
    d: "M798.006 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.022.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.022.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-118.992 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19119",
    d: "M812.357 154.519v-1.994h4.519V169.9h-2.211v-15.381Z",
    transform: "translate(-118.97 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19120",
    d: "M830.5 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.022.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.022.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-118.944 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19121",
    d: "M849.358 167.355a3.537 3.537 0 0 0 2.367.745 3.2 3.2 0 0 0 2.944-1.563q.948-1.561.9-5.264a3.63 3.63 0 0 1-1.682 1.7 5.589 5.589 0 0 1-2.62.613 6.11 6.11 0 0 1-2.872-.661 4.8 4.8 0 0 1-1.983-1.936 6.149 6.149 0 0 1-.721-3.076 5.782 5.782 0 0 1 1.49-4.147 5.549 5.549 0 0 1 4.23-1.574q3.365 0 4.723 2.188t1.358 6.514a19.311 19.311 0 0 1-.541 5 5.628 5.628 0 0 1-1.827 3 5.475 5.475 0 0 1-3.521 1.034 5.276 5.276 0 0 1-3.822-1.322 5.186 5.186 0 0 1-1.562-3.366h2.019a3.434 3.434 0 0 0 1.12 2.115Zm4.915-6.623a3.58 3.58 0 0 0 1.034-2.7 4.144 4.144 0 0 0-1.01-2.907 3.648 3.648 0 0 0-2.836-1.107 3.508 3.508 0 0 0-2.68 1.059 3.9 3.9 0 0 0-1 2.787 3.961 3.961 0 0 0 .985 2.813 3.719 3.719 0 0 0 2.86 1.058 3.647 3.647 0 0 0 2.648-1.002Z",
    transform: "translate(-118.921 -148.75)",
    fill: "url(#banner-title_svg__x)"
  })))));
};
/* harmony default export */ var banner_title = (SvgBannerTitle);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/banner-title-mobile.svg
var banner_title_mobile_defs, banner_title_mobile_g;
function banner_title_mobile_extends() { banner_title_mobile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return banner_title_mobile_extends.apply(this, arguments); }

var SvgBannerTitleMobile = function SvgBannerTitleMobile(props) {
  return /*#__PURE__*/react.createElement("svg", banner_title_mobile_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 106.586"
  }, props), banner_title_mobile_defs || (banner_title_mobile_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__a",
    x1: 0.5,
    y1: -0.041,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__b",
    x1: 0.5,
    y1: -0.026,
    x2: 0.5,
    y2: 0.911,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__c",
    x1: 0.5,
    y1: -0.006,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__d",
    x1: 0.5,
    y1: 0.092,
    x2: 0.5,
    y2: 0.836,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__e",
    x1: 0.5,
    y1: -0.005,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__f",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.814,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__g",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.813,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__h",
    x1: 0.5,
    y1: 0.061,
    x2: 0.5,
    y2: 0.842,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__i",
    x1: 0.5,
    y1: 0.058,
    x2: 0.5,
    y2: 0.832,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__j",
    x1: 0.5,
    y1: 0.041,
    x2: 0.5,
    y2: 0.827,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__k",
    x1: 0.5,
    y1: -0.252,
    x2: 0.5,
    y2: 0.884,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__l",
    x1: 0.5,
    y1: -0.147,
    x2: 0.5,
    y2: 0.894,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__m",
    x1: 0.5,
    y1: -0.084,
    x2: 0.5,
    y2: 0.816,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__n",
    x1: 0.5,
    y1: -0.03,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__o",
    x1: 0.5,
    y1: -0.108,
    x2: 0.5,
    y2: 0.817,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__p",
    x1: 0.5,
    y1: -0.031,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__q",
    x1: 0.5,
    y1: -0.039,
    x2: 0.5,
    y2: 0.828,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__r",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.799,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__s",
    x1: 0.5,
    y1: -0.188,
    x2: 0.5,
    y2: 0.9,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__t",
    x1: 0.5,
    y1: -0.189,
    x2: 0.5,
    y2: 0.89,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__u",
    x1: 0.5,
    y1: -0.207,
    x2: 0.5,
    y2: 0.888,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__v",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__w",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__x",
    x1: 0.5,
    y1: -0.184,
    x2: 0.5,
    y2: 0.889,
    xlinkHref: "#banner-title-mobile_svg__a"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "banner-title-mobile_svg__y",
    x1: 0.5,
    y1: -6.075,
    x2: 0.5,
    y2: 4.212,
    xlinkHref: "#banner-title-mobile_svg__a"
  }))), banner_title_mobile_g || (banner_title_mobile_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7669"
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7666",
    opacity: 0.4
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7660"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19064",
    d: "M10.488 44.331v7.8h12.574v7.248H10.488v8.456h14.221v7.523H1.099v-38.55h23.61v7.523Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19065",
    d: "M56.283 75.356 48.43 63.55l-6.918 11.806H30.859l12.355-19.6-12.63-18.944h10.928l7.742 11.641 6.809-11.641h10.653L54.471 56.247 67.21 75.356Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19066",
    d: "M101.639 55.339a11.3 11.3 0 0 1-4.722 4.475 16.624 16.624 0 0 1-7.907 1.7h-5.82v13.838H73.8V36.808h15.21a17.312 17.312 0 0 1 7.8 1.593 10.949 10.949 0 0 1 4.777 4.393 12.767 12.767 0 0 1 1.593 6.424 12.413 12.413 0 0 1-1.541 6.121Zm-9.335-2.553a5.491 5.491 0 0 0 0-7.138 5.6 5.6 0 0 0-4.009-1.263h-5.106v9.665h5.106a5.6 5.6 0 0 0 4.009-1.263Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19067",
    d: "M119.32 68.108h12.3v7.248h-21.689V36.808h9.389Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19068",
    d: "M146.253 73.209a18.875 18.875 0 0 1-7.193-7.056 20.76 20.76 0 0 1 0-20.344 18.947 18.947 0 0 1 7.193-7.029 20.926 20.926 0 0 1 19.932 0 18.552 18.552 0 0 1 7.138 7.029 21.044 21.044 0 0 1-.027 20.344 18.741 18.741 0 0 1-7.138 7.056 20.871 20.871 0 0 1-19.9 0Zm17.348-9.11a13.336 13.336 0 0 0 0-16.281 9.5 9.5 0 0 0-7.386-3.047 9.611 9.611 0 0 0-7.44 3.02 13.417 13.417 0 0 0 0 16.336 9.566 9.566 0 0 0 7.44 3.047 9.458 9.458 0 0 0 7.386-3.075Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19069",
    d: "m202.673 75.356-8.017-14.551h-2.251v14.551h-9.39V36.808h15.759a17.35 17.35 0 0 1 7.77 1.593 10.98 10.98 0 0 1 4.8 4.366 12.181 12.181 0 0 1 1.592 6.177 11.474 11.474 0 0 1-2.169 6.864 11.674 11.674 0 0 1-6.4 4.283l8.9 15.265Zm-10.268-21.2h5.821a5.326 5.326 0 0 0 3.871-1.263 4.769 4.769 0 0 0 1.291-3.569 4.621 4.621 0 0 0-1.291-3.459 5.329 5.329 0 0 0-3.871-1.263h-5.821Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19070",
    d: "M230.073 44.331v7.8h12.57v7.248h-12.57v8.456h14.223v7.523h-23.612v-38.55h23.611v7.523Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19071",
    d: "M293.493 36.808v7.523H283.28v31.025h-9.39V44.331h-10.213v-7.523Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19072",
    d: "M333.468 36.808v38.548h-9.389v-15.87h-14.607v15.87h-9.39V36.808h9.39v15.1h14.606v-15.1Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19073",
    d: "M351.478 44.331v7.8h12.575v7.248h-12.575v8.456h14.223v7.523h-23.616v-38.55h23.611v7.523Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19074",
    d: "M393.538 74.367a12.348 12.348 0 0 1-5.354-4.064 11.094 11.094 0 0 1-2.114-6.479h9.994a4.84 4.84 0 0 0 1.482 3.267 4.763 4.763 0 0 0 3.295 1.126 5.152 5.152 0 0 0 3.294-.961 3.216 3.216 0 0 0 1.208-2.663 3.156 3.156 0 0 0-.961-2.362 7.775 7.775 0 0 0-2.361-1.537 38.17 38.17 0 0 0-3.982-1.373 43.333 43.333 0 0 1-6.095-2.306 11.257 11.257 0 0 1-4.064-3.4 9.484 9.484 0 0 1-1.7-5.876 10.1 10.1 0 0 1 3.9-8.428q3.9-3.047 10.159-3.047 6.37 0 10.268 3.047a10.912 10.912 0 0 1 4.173 8.483h-10.16a3.976 3.976 0 0 0-1.373-2.938 4.836 4.836 0 0 0-3.24-1.07 4.038 4.038 0 0 0-2.746.906 3.269 3.269 0 0 0-1.043 2.609 3.232 3.232 0 0 0 1.758 2.91 28.686 28.686 0 0 0 5.491 2.251 51 51 0 0 1 6.068 2.417 11.553 11.553 0 0 1 4.035 3.349 8.965 8.965 0 0 1 1.7 5.656 11.1 11.1 0 0 1-1.674 5.985 11.732 11.732 0 0 1-4.86 4.283 16.627 16.627 0 0 1-7.523 1.592 19.815 19.815 0 0 1-7.575-1.377Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19075",
    d: "m445.153 75.356-12.959-17.023v17.023h-9.389V36.808h9.389v16.913l12.85-16.913h11.037l-14.936 18.89 15.485 19.658Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19076",
    d: "m496 36.808-13.343 25.808v12.74h-9.39v-12.74l-13.343-25.808h10.653l7.468 16.144 7.413-16.144Z"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7661"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19077",
    d: "M9.365 94.621v1.585H6.209v10.26H4.265v-10.26H1.099v-1.585Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19078",
    d: "M27.789 95.474a1.244 1.244 0 0 1 .886-2.131 1.184 1.184 0 0 1 .869.358 1.277 1.277 0 0 1 0 1.773 1.184 1.184 0 0 1-.869.358 1.2 1.2 0 0 1-.886-.358Zm1.841 1.6v9.389h-1.944v-9.391Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19079",
    d: "M55.731 95.346a5.185 5.185 0 0 1 2.2 2.08 6.252 6.252 0 0 1 .776 3.161 6.114 6.114 0 0 1-.776 3.136 5.121 5.121 0 0 1-2.2 2.037 7.358 7.358 0 0 1-3.315.707h-3.869V94.621h3.868a7.212 7.212 0 0 1 3.316.725Zm-.128 8.411a4.326 4.326 0 0 0 1.108-3.17 4.469 4.469 0 0 0-1.108-3.221 4.2 4.2 0 0 0-3.187-1.159H50.49v8.676h1.925a4.278 4.278 0 0 0 3.188-1.126Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19080",
    d: "M84.953 101.387a3.042 3.042 0 0 1 .2 3.52 3.18 3.18 0 0 1-1.355 1.142 4.8 4.8 0 0 1-2.062.417H76.99V94.621h4.516a4.836 4.836 0 0 1 2.079.41 3.055 3.055 0 0 1 1.313 1.1 2.8 2.8 0 0 1 .443 1.543 2.647 2.647 0 0 1-.545 1.7 3.181 3.181 0 0 1-1.466 1 2.625 2.625 0 0 1 1.623 1.013Zm-6.017-1.789h2.4a2.307 2.307 0 0 0 1.491-.435 1.516 1.516 0 0 0 .537-1.252 1.548 1.548 0 0 0-.537-1.253 2.25 2.25 0 0 0-1.491-.451h-2.4Zm4.175 4.806a1.649 1.649 0 0 0 .563-1.329 1.725 1.725 0 0 0-.6-1.38 2.352 2.352 0 0 0-1.585-.511h-2.557v3.7h2.624a2.324 2.324 0 0 0 1.555-.48Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19081",
    d: "M134.343 94.621v11.846h-1.942v-5.181h-5.574v5.181h-1.942V94.621h1.942V99.7h5.574v-5.079Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19082",
    d: "M160.402 104.046h-4.96l-.853 2.42h-2.028l4.244-11.862h2.25l4.244 11.862h-2.045Zm-.546-1.585-1.926-5.506-1.943 5.506Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19083",
    d: "M181.664 97.399a5.767 5.767 0 0 1 2.2-2.157 6.467 6.467 0 0 1 6.408.153 5.291 5.291 0 0 1 2.139 2.634h-2.335a3.131 3.131 0 0 0-1.278-1.4 3.8 3.8 0 0 0-1.892-.459 4.134 4.134 0 0 0-2.1.528 3.676 3.676 0 0 0-1.44 1.517 5.352 5.352 0 0 0 0 4.6 3.735 3.735 0 0 0 1.44 1.526 4.086 4.086 0 0 0 2.1.537 3.8 3.8 0 0 0 1.892-.461 3.13 3.13 0 0 0 1.278-1.4h2.335a5.24 5.24 0 0 1-2.139 2.624 6.224 6.224 0 0 1-3.366.92 6.121 6.121 0 0 1-3.051-.775 5.79 5.79 0 0 1-2.19-2.156 6.411 6.411 0 0 1 0-6.238Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19084",
    d: "m217.565 106.467-4.585-5.3v5.3h-1.943V94.621h1.943v5.4l4.6-5.4h2.437l-5.147 5.931 5.232 5.914Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19085",
    d: "M245.329 104.046h-4.96l-.853 2.42h-2.028l4.244-11.862h2.25l4.244 11.862h-2.045Zm-.546-1.585-1.926-5.506-1.943 5.506Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19086",
    d: "M274.081 94.621v1.585h-3.153v10.26h-1.943v-10.26h-3.17v-1.585Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19087",
    d: "M301.862 94.621v11.846h-1.943v-5.181h-5.573v5.181h-1.943V94.621h1.943V99.7h5.573v-5.079Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19088",
    d: "M323.14 105.808a5.749 5.749 0 0 1-2.2-2.165 6.426 6.426 0 0 1 0-6.246 5.77 5.77 0 0 1 2.2-2.157 6.393 6.393 0 0 1 6.1 0 5.7 5.7 0 0 1 2.19 2.157 6.488 6.488 0 0 1 0 6.246 5.682 5.682 0 0 1-2.19 2.165 6.388 6.388 0 0 1-6.1 0Zm5.139-1.448a3.726 3.726 0 0 0 1.44-1.535 4.931 4.931 0 0 0 .52-2.309 4.878 4.878 0 0 0-.52-2.3 3.681 3.681 0 0 0-1.44-1.517 4.427 4.427 0 0 0-4.193 0 3.672 3.672 0 0 0-1.44 1.517 4.869 4.869 0 0 0-.52 2.3 4.922 4.922 0 0 0 .52 2.309 3.717 3.717 0 0 0 1.44 1.535 4.364 4.364 0 0 0 4.193 0Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19089",
    d: "M360.236 106.466h-1.943l-5.846-8.845v8.845h-1.943V94.604h1.943l5.846 8.829v-8.829h1.943Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19090",
    d: "M400.768 103.825q1.637-1.415 2.583-2.327a10.489 10.489 0 0 0 1.577-1.9 3.655 3.655 0 0 0 .63-1.976 2.422 2.422 0 0 0-.486-1.6 1.883 1.883 0 0 0-1.525-.579 1.953 1.953 0 0 0-1.56.639 2.659 2.659 0 0 0-.588 1.713h-1.875a4.173 4.173 0 0 1 6.911-2.982 3.634 3.634 0 0 1 1.048 2.727 4.843 4.843 0 0 1-.622 2.36 9.53 9.53 0 0 1-1.483 2.028q-.861.9-2.19 2.071l-.767.682h5.4v1.619h-8.283v-1.414Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19091",
    d: "M426.882 95.482a4.379 4.379 0 0 1 6.868 0 8.973 8.973 0 0 1 1 4.611 9.146 9.146 0 0 1-1 4.661 4.351 4.351 0 0 1-6.868 0 9.152 9.152 0 0 1-1-4.661 8.98 8.98 0 0 1 1-4.611Zm5.778 2.276a3.132 3.132 0 0 0-.725-1.559 2.468 2.468 0 0 0-3.238 0 3.131 3.131 0 0 0-.724 1.559 12.927 12.927 0 0 0-.179 2.335 14.2 14.2 0 0 0 .17 2.4 3 3 0 0 0 .724 1.568 2.518 2.518 0 0 0 3.256 0 3.005 3.005 0 0 0 .724-1.568 14.2 14.2 0 0 0 .171-2.4 12.937 12.937 0 0 0-.179-2.335Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19092",
    d: "M454.246 103.825q1.637-1.415 2.583-2.327a10.466 10.466 0 0 0 1.577-1.9 3.655 3.655 0 0 0 .63-1.976 2.423 2.423 0 0 0-.486-1.6 1.882 1.882 0 0 0-1.525-.579 1.953 1.953 0 0 0-1.56.639 2.658 2.658 0 0 0-.588 1.713h-1.878a4.173 4.173 0 0 1 6.911-2.982 3.634 3.634 0 0 1 1.048 2.727 4.843 4.843 0 0 1-.622 2.36 9.507 9.507 0 0 1-1.483 2.028q-.861.9-2.19 2.071l-.767.682h5.403v1.619h-8.28v-1.414Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19093",
    d: "M479.112 95.819v-1.773h3.545v12.425h-1.96V95.819Z"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7662"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19094",
    d: "M8.924 4.042v1.189H5.87v10.014H4.407V5.231h-3.07V4.042Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19095",
    d: "M17.394 4.717a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.03 1.03 0 0 1 0 1.415.917.917 0 0 1-.683.289.962.962 0 0 1-.707-.293Zm1.415 1.719v8.809h-1.463V6.436Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19096",
    d: "M34.584 4.725a4.8 4.8 0 0 1 2.058 1.953 6.589 6.589 0 0 1 0 5.972 4.718 4.718 0 0 1-2.058 1.929 7.057 7.057 0 0 1-3.175.667h-3.485v-11.2h3.488a6.917 6.917 0 0 1 3.172.679Zm.137 8.166a4.375 4.375 0 0 0 1.141-3.223 4.465 4.465 0 0 0-1.149-3.264 4.419 4.419 0 0 0-3.3-1.173h-2.029v8.809h2.025a4.466 4.466 0 0 0 3.314-1.147Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19097",
    d: "M52.638 9.973a2.924 2.924 0 0 1 .8 1 2.9 2.9 0 0 1-.137 2.8 2.95 2.95 0 0 1-1.262 1.078 4.509 4.509 0 0 1-1.953.394h-4.171v-11.2h4.019a4.548 4.548 0 0 1 1.945.378 2.753 2.753 0 0 1 1.206 1.021 2.677 2.677 0 0 1 .4 1.446 2.5 2.5 0 0 1-.538 1.648 3.018 3.018 0 0 1-1.423.94 2.374 2.374 0 0 1 1.114.495ZM47.374 8.88h2.459a2.375 2.375 0 0 0 1.591-.482 1.863 1.863 0 0 0 0-2.668 2.425 2.425 0 0 0-1.624-.482h-2.427Zm4.292 4.645a1.766 1.766 0 0 0 .611-1.43 1.819 1.819 0 0 0-.643-1.471 2.6 2.6 0 0 0-1.72-.538h-2.54v3.954h2.588a2.566 2.566 0 0 0 1.704-.515Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19098",
    d: "M86.515 12.702H72.321v-1.061h6.478v-1.439h-5.16v-.981h5.16V7.902h-4.887v-5.5h10.947v5.5h-4.886V9.22h5.192v.981h-5.192v1.447h6.542Zm-14.179 3.311a7.144 7.144 0 0 0 1.785-2.668l1.141.273a8.406 8.406 0 0 1-1.816 2.926Zm6.463-9.132V3.41h-3.745v3.471Zm-2.058-3.07a8.4 8.4 0 0 1 1.045 2.347l-.836.322a9.638 9.638 0 0 0-1-2.4Zm1.222 9.854a12.285 12.285 0 0 1 .354 2.557l-1.173.161a15.287 15.287 0 0 0-.289-2.637ZM83.67 3.41h-3.7v3.471h3.7Zm-2.411 10.143a14.933 14.933 0 0 1 .916 2.54l-1.173.289a18.733 18.733 0 0 0-.852-2.6Zm-.563-7.217a16.824 16.824 0 0 0 1.238-2.54l.932.354c-.45.868-.981 1.865-1.4 2.508Zm3.778 7.009a15.214 15.214 0 0 1 2.122 2.7l-1.158.45a16.228 16.228 0 0 0-2.041-2.782Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19099",
    d: "M106.496 6.275a11.026 11.026 0 0 1-3.2 3.071 21.14 21.14 0 0 0 6.221 1.7 5.288 5.288 0 0 0-.756 1.126 17.29 17.29 0 0 1-2.235-.451v4.726h-1.206v-.514h-6.349v.53h-1.158v-4.662c-.852.258-1.7.45-2.54.627a4.447 4.447 0 0 0-.579-1.045 23.953 23.953 0 0 0 6.318-2.009 11.829 11.829 0 0 1-2.106-1.849 14.5 14.5 0 0 1-2.508 1.559 3.672 3.672 0 0 0-.8-.852 10.722 10.722 0 0 0 4.565-3.6l1.287.226c-.225.321-.482.626-.739.948h4.774l.209-.048Zm-9.967-.015h-1.168V3.237h6.4c-.226-.418-.482-.9-.723-1.286l1.157-.29a15.66 15.66 0 0 1 .932 1.576h5.723V6.26h-1.206V4.346H96.529Zm9.388 5.305a19.525 19.525 0 0 1-3.794-1.528 20.961 20.961 0 0 1-3.585 1.528Zm-.595 3.343v-2.331h-6.349v2.331Zm-5.578-8.086a10.122 10.122 0 0 0 2.4 1.945 11.215 11.215 0 0 0 2.524-2.009h-4.855Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19100",
    d: "M128.165 13.139h-10.417v-1.141h10.417Zm3.311-4.212s-.016.386-.048.563c-.37 4.179-.723 5.836-1.35 6.447a1.679 1.679 0 0 1-1.286.514 22.9 22.9 0 0 1-2.524-.031 2.781 2.781 0 0 0-.369-1.157c1.029.1 2.057.113 2.459.113a1.007 1.007 0 0 0 .707-.177c.466-.418.8-1.833 1.125-5.16h-10.256c.193-1.287.4-3.376.514-4.936l1.173.08c-.1 1.173-.241 2.589-.37 3.746h6.238c.209-1.624.418-3.585.563-5h-9.083V2.772h9.292l.193-.064.868.1a132.377 132.377 0 0 1-.643 6.124Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19101",
    d: "M145.397 9.959c-.627.193-1.238.386-1.849.563v4.582c0 .659-.145.948-.547 1.141a4.611 4.611 0 0 1-1.961.208 4.965 4.965 0 0 0-.354-1.076c.643.016 1.254.016 1.415 0 .209 0 .289-.065.289-.29v-4.228l-1.849.547-.338-1.157c.611-.145 1.366-.354 2.186-.579V6.15h-1.977V5.04h1.977V1.809h1.157V5.04h1.688v1.11h-1.688v3.209l1.7-.5Zm9.532 4.71v1.142h-9.774v-1.142h5.434a62.313 62.313 0 0 0 1.511-7.957l1.27.225c-.434 2.475-1.077 5.61-1.672 7.732Zm-.418-8.842h-8.6V4.702h8.6Zm-6.414 8.1a61.189 61.189 0 0 0-1.094-6.849l1.045-.225a60.529 60.529 0 0 1 1.206 6.736Zm1.543-9.4a17.957 17.957 0 0 0-.772-2.556l1.125-.289a20.963 20.963 0 0 1 .8 2.492Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19102",
    d: "M167.921 11.098c-.257-.595-.836-1.656-1.35-2.54v7.91h-1.173V8.944a18.051 18.051 0 0 1-2.009 4.581 6.882 6.882 0 0 0-.66-1.157 16.817 16.817 0 0 0 2.54-6.061h-2.3V5.181h2.428V1.789h1.173v3.392h1.993v1.122h-1.993v.643c.547.723 1.881 2.684 2.17 3.167Zm4.2-8.552a17.1 17.1 0 0 1-2.782 6.51 9.162 9.162 0 0 0-1.045-.707 13.791 13.791 0 0 0 2.6-6.013Zm2.829 8.343a29.873 29.873 0 0 1 2.234 4.743l-1.093.514a11.357 11.357 0 0 0-.434-1.2c-5.353.707-6.061.82-6.511 1.045h-.025v-.064c-.1-.274-.289-.82-.434-1.142.354-.1.659-.626 1.045-1.415a34.37 34.37 0 0 0 2.4-6.43l1.238.466a41.687 41.687 0 0 1-2.846 7.057l4.711-.563c-.4-.883-.836-1.8-1.27-2.588Zm-.177-8.729a15.729 15.729 0 0 0 2.717 5.884 3.929 3.929 0 0 0-.948.981 18.5 18.5 0 0 1-2.893-6.607Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19103",
    d: "M203.457 1.099v16.076h-.675V1.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19104",
    d: "M232.02 11.379a12.955 12.955 0 0 0 1.954-2.2 3.967 3.967 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.851 2.851 0 0 0-.65 1.825h-1.416a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.367 11.367 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.043-1.639 3.201-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19105",
    d: "M245.765 4.999a3.957 3.957 0 0 1 6.284 0 8.64 8.64 0 0 1 .9 4.315 8.808 8.808 0 0 1-.9 4.373 3.946 3.946 0 0 1-6.284 0 8.8 8.8 0 0 1-.9-4.373 8.632 8.632 0 0 1 .9-4.315Zm5.554 1.944a3.028 3.028 0 0 0-.756-1.567 2.605 2.605 0 0 0-3.312 0 3.018 3.018 0 0 0-.756 1.567 12.952 12.952 0 0 0-.185 2.371 13.39 13.39 0 0 0 .185 2.427 3.022 3.022 0 0 0 .756 1.576 2.6 2.6 0 0 0 3.312 0 3.031 3.031 0 0 0 .756-1.576 13.452 13.452 0 0 0 .184-2.427 13.012 13.012 0 0 0-.182-2.371Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19106",
    d: "M264.604 11.379a12.954 12.954 0 0 0 1.953-2.2 3.968 3.968 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.017 2.017 0 0 0-1.632-.6 2.144 2.144 0 0 0-1.7.682 2.852 2.852 0 0 0-.651 1.825h-1.415a3.864 3.864 0 0 1 1.093-2.782 4.152 4.152 0 0 1 5.281-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.367 11.367 0 0 1-1.808 2.219q-1.013.956-2.588 2.226h5.53v1.221h-7.732v-1.051q2.044-1.639 3.202-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19107",
    d: "M277.061 4.957V3.624h3.022v11.622h-1.479V4.957Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19108",
    d: "M289.213 15.053a1 1 0 0 1 .707-1.7.916.916 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.916.916 0 0 1-.683.289.962.962 0 0 1-.707-.293Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19109",
    d: "M298.826 4.957V3.624h3.021v11.622h-1.479V4.957Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19110",
    d: "M314 11.379a12.946 12.946 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.486 2.486 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.847 2.847 0 0 0-.65 1.825h-1.415a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.368 11.368 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.529v1.221h-7.731v-1.051q2.043-1.639 3.201-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19111",
    d: "M326.844 15.053a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.03 1.03 0 0 1 0 1.415.917.917 0 0 1-.683.289.961.961 0 0 1-.707-.293Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19112",
    d: "M339.47 13.542a2.365 2.365 0 0 0 1.583.5 2.141 2.141 0 0 0 1.969-1.046 6.979 6.979 0 0 0 .6-3.52 2.428 2.428 0 0 1-1.125 1.134 3.739 3.739 0 0 1-1.752.41 4.086 4.086 0 0 1-1.921-.442 3.209 3.209 0 0 1-1.326-1.295 4.113 4.113 0 0 1-.482-2.057 3.87 3.87 0 0 1 1-2.774 3.711 3.711 0 0 1 2.829-1.053 3.419 3.419 0 0 1 3.159 1.463 8.38 8.38 0 0 1 .908 4.356 12.909 12.909 0 0 1-.362 3.344 3.762 3.762 0 0 1-1.222 2.009 3.662 3.662 0 0 1-2.355.691 3.529 3.529 0 0 1-2.556-.884 3.469 3.469 0 0 1-1.045-2.251h1.35a2.3 2.3 0 0 0 .748 1.415Zm3.287-4.429a2.394 2.394 0 0 0 .691-1.808 2.772 2.772 0 0 0-.675-1.944 2.439 2.439 0 0 0-1.9-.74 2.347 2.347 0 0 0-1.792.708 2.606 2.606 0 0 0-.667 1.864 2.649 2.649 0 0 0 .659 1.881 2.487 2.487 0 0 0 1.913.707 2.439 2.439 0 0 0 1.771-.671Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19113",
    d: "M370.855 8.736v1.238h-6.414V8.736Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19114",
    d: "M393.922 11.379a12.978 12.978 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.146 2.146 0 0 0-1.7.682 2.852 2.852 0 0 0-.65 1.825h-1.415a3.862 3.862 0 0 1 1.094-2.782 4.152 4.152 0 0 1 5.281-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.39 11.39 0 0 1-1.808 2.219q-1.013.956-2.588 2.226h5.53v1.221h-7.732v-1.051q2.041-1.639 3.2-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19115",
    d: "M407.666 4.999a3.957 3.957 0 0 1 6.284 0 8.64 8.64 0 0 1 .9 4.315 8.807 8.807 0 0 1-.9 4.373 3.946 3.946 0 0 1-6.284 0 8.8 8.8 0 0 1-.9-4.373 8.632 8.632 0 0 1 .9-4.315Zm5.554 1.944a3.019 3.019 0 0 0-.756-1.567 2.6 2.6 0 0 0-3.312 0 3.019 3.019 0 0 0-.756 1.567 12.962 12.962 0 0 0-.184 2.371 13.4 13.4 0 0 0 .184 2.427 3.023 3.023 0 0 0 .756 1.576 2.6 2.6 0 0 0 3.312 0 3.022 3.022 0 0 0 .756-1.576 13.45 13.45 0 0 0 .184-2.427 13.01 13.01 0 0 0-.185-2.371Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19116",
    d: "M426.505 11.379a12.976 12.976 0 0 0 1.953-2.2 3.967 3.967 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.146 2.146 0 0 0-1.7.682 2.851 2.851 0 0 0-.65 1.825h-1.415a3.861 3.861 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.366 11.366 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.042-1.639 3.201-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19117",
    d: "M442.371 11.379a12.973 12.973 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.852 2.852 0 0 0-.65 1.825h-1.418a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .972 2.523 4.807 4.807 0 0 1-.8 2.6 11.366 11.366 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.046-1.639 3.205-2.693Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19118",
    d: "M455.214 15.053a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.917.917 0 0 1-.683.289.962.962 0 0 1-.707-.293Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19119",
    d: "M464.826 4.957V3.624h3.022v11.622h-1.479V4.957Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19120",
    d: "M476.978 15.053a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.917.917 0 0 1-.683.289.961.961 0 0 1-.707-.293Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19121",
    d: "M489.605 13.542a2.366 2.366 0 0 0 1.583.5 2.141 2.141 0 0 0 1.969-1.046 6.987 6.987 0 0 0 .6-3.52 2.427 2.427 0 0 1-1.125 1.134 3.738 3.738 0 0 1-1.752.41 4.086 4.086 0 0 1-1.921-.442 3.21 3.21 0 0 1-1.326-1.295 4.112 4.112 0 0 1-.482-2.057 3.867 3.867 0 0 1 1-2.774 3.711 3.711 0 0 1 2.829-1.053 3.419 3.419 0 0 1 3.159 1.463 8.379 8.379 0 0 1 .908 4.356 12.912 12.912 0 0 1-.362 3.344 3.764 3.764 0 0 1-1.224 2.008 3.661 3.661 0 0 1-2.355.691 3.529 3.529 0 0 1-2.556-.884 3.468 3.468 0 0 1-1.045-2.251h1.35a2.3 2.3 0 0 0 .75 1.416Zm3.287-4.429a2.394 2.394 0 0 0 .691-1.808 2.771 2.771 0 0 0-.675-1.944 2.44 2.44 0 0 0-1.9-.74 2.346 2.346 0 0 0-1.792.708 2.606 2.606 0 0 0-.667 1.864 2.649 2.649 0 0 0 .659 1.881 2.487 2.487 0 0 0 1.913.707 2.439 2.439 0 0 0 1.771-.671Z"
  }))), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7669"
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7660"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19064",
    d: "M129.379 209.592v7.8h12.574v7.248h-12.574v8.456H143.6v7.523h-23.61v-38.55h23.61v7.523Z",
    transform: "translate(-119.99 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19065",
    d: "m189.712 240.617-7.853-11.806-6.918 11.806h-10.653l12.355-19.6-12.63-18.944h10.928l7.742 11.641 6.809-11.641h10.653L187.9 221.508l12.739 19.109Z",
    transform: "translate(-134.528 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19066",
    d: "M256.375 220.6a11.3 11.3 0 0 1-4.722 4.475 16.624 16.624 0 0 1-7.907 1.7h-5.82v13.838h-9.39v-38.544h15.21a17.312 17.312 0 0 1 7.8 1.593 10.949 10.949 0 0 1 4.777 4.393 12.767 12.767 0 0 1 1.593 6.424 12.413 12.413 0 0 1-1.541 6.121Zm-9.335-2.553a5.491 5.491 0 0 0 0-7.138 5.6 5.6 0 0 0-4.009-1.263h-5.106v9.665h5.106a5.6 5.6 0 0 0 4.009-1.263Z",
    transform: "translate(-155.835 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19067",
    d: "M291.87 233.369h12.3v7.248h-21.689v-38.548h9.389Z",
    transform: "translate(-173.649 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19068",
    d: "M331.852 238.2a18.875 18.875 0 0 1-7.193-7.056 20.76 20.76 0 0 1 0-20.344 18.947 18.947 0 0 1 7.193-7.029 20.926 20.926 0 0 1 19.932 0 18.552 18.552 0 0 1 7.138 7.029 21.044 21.044 0 0 1-.027 20.344 18.741 18.741 0 0 1-7.138 7.056 20.871 20.871 0 0 1-19.9 0Zm17.348-9.11a13.336 13.336 0 0 0 0-16.281 9.5 9.5 0 0 0-7.386-3.047 9.611 9.611 0 0 0-7.44 3.02 13.417 13.417 0 0 0 0 16.336 9.566 9.566 0 0 0 7.44 3.047 9.458 9.458 0 0 0 7.386-3.075Z",
    transform: "translate(-186.698 -166.09)",
    fill: "url(#banner-title-mobile_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19069",
    d: "m411.258 240.617-8.017-14.551h-2.251v14.551h-9.39v-38.548h15.759a17.35 17.35 0 0 1 7.77 1.593 10.98 10.98 0 0 1 4.8 4.366 12.181 12.181 0 0 1 1.592 6.177 11.474 11.474 0 0 1-2.169 6.864 11.674 11.674 0 0 1-6.4 4.283l8.9 15.265Zm-10.268-21.2h5.821a5.326 5.326 0 0 0 3.871-1.263 4.769 4.769 0 0 0 1.291-3.569 4.621 4.621 0 0 0-1.291-3.459 5.329 5.329 0 0 0-3.871-1.263h-5.821Z",
    transform: "translate(-209.684 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19070",
    d: "M457.23 209.592v7.8h12.57v7.248h-12.57v8.456h14.223v7.523h-23.612v-38.55h23.611v7.523Z",
    transform: "translate(-228.256 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19071",
    d: "M541.848 202.069v7.523h-10.213v31.025h-9.39v-31.025h-10.213v-7.523Z",
    transform: "translate(-249.454 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19072",
    d: "M599.772 202.069v38.548h-9.389v-15.87h-14.607v15.87h-9.39v-38.548h9.39v15.1h14.606v-15.1Z",
    transform: "translate(-267.403 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19073",
    d: "M638.493 209.592v7.8h12.575v7.248h-12.575v8.456h14.223v7.523H629.1v-38.55h23.611v7.523Z",
    transform: "translate(-288.114 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19074",
    d: "M702.239 239.358a12.348 12.348 0 0 1-5.354-4.064 11.094 11.094 0 0 1-2.114-6.479h9.994a4.84 4.84 0 0 0 1.482 3.267 4.763 4.763 0 0 0 3.295 1.126 5.152 5.152 0 0 0 3.294-.961 3.216 3.216 0 0 0 1.208-2.663 3.156 3.156 0 0 0-.961-2.362 7.775 7.775 0 0 0-2.361-1.537 38.17 38.17 0 0 0-3.982-1.373 43.333 43.333 0 0 1-6.095-2.306 11.257 11.257 0 0 1-4.064-3.4 9.484 9.484 0 0 1-1.7-5.876 10.1 10.1 0 0 1 3.9-8.428q3.9-3.047 10.159-3.047 6.37 0 10.268 3.047a10.912 10.912 0 0 1 4.173 8.483h-10.16a3.976 3.976 0 0 0-1.373-2.938 4.836 4.836 0 0 0-3.24-1.07 4.038 4.038 0 0 0-2.746.906 3.269 3.269 0 0 0-1.043 2.609 3.232 3.232 0 0 0 1.758 2.91 28.686 28.686 0 0 0 5.491 2.251 51 51 0 0 1 6.068 2.417 11.553 11.553 0 0 1 4.035 3.349 8.965 8.965 0 0 1 1.7 5.656 11.1 11.1 0 0 1-1.674 5.985 11.732 11.732 0 0 1-4.86 4.283 16.627 16.627 0 0 1-7.523 1.592 19.815 19.815 0 0 1-7.575-1.377Z",
    transform: "translate(-309.8 -166.09)",
    fill: "url(#banner-title-mobile_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19075",
    d: "m771.966 240.617-12.959-17.023v17.023h-9.389v-38.548h9.389v16.913l12.85-16.913h11.037l-14.936 18.89 15.485 19.658Z",
    transform: "translate(-327.912 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19076",
    d: "m841.114 202.069-13.343 25.808v12.74h-9.39v-12.74l-13.343-25.808h10.653l7.468 16.144 7.413-16.144Z",
    transform: "translate(-346.213 -166.36)",
    fill: "url(#banner-title-mobile_svg__a)"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7661"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19077",
    d: "M128.256 288.388v1.585H125.1v10.26h-1.944v-10.26h-3.166v-1.585Z",
    transform: "translate(-119.99 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19078",
    d: "M159.663 288.611a1.244 1.244 0 0 1 .886-2.131 1.184 1.184 0 0 1 .869.358 1.277 1.277 0 0 1 0 1.773 1.184 1.184 0 0 1-.869.358 1.2 1.2 0 0 1-.886-.358Zm1.841 1.6v9.389h-1.944v-9.391Z",
    transform: "translate(-132.973 -194.236)",
    fill: "url(#banner-title-mobile_svg__d)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19079",
    d: "M198.016 289.113a5.185 5.185 0 0 1 2.2 2.08 6.252 6.252 0 0 1 .776 3.161 6.114 6.114 0 0 1-.776 3.136 5.121 5.121 0 0 1-2.2 2.037 7.358 7.358 0 0 1-3.315.707h-3.869v-11.846h3.868a7.212 7.212 0 0 1 3.316.725Zm-.128 8.411a4.326 4.326 0 0 0 1.108-3.17 4.469 4.469 0 0 0-1.108-3.221 4.2 4.2 0 0 0-3.187-1.159h-1.926v8.676h1.925a4.278 4.278 0 0 0 3.188-1.126Z",
    transform: "translate(-143.384 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19080",
    d: "M241.263 295.154a3.042 3.042 0 0 1 .2 3.52 3.18 3.18 0 0 1-1.355 1.142 4.8 4.8 0 0 1-2.062.417H233.3v-11.845h4.516a4.836 4.836 0 0 1 2.079.41 3.055 3.055 0 0 1 1.313 1.1 2.8 2.8 0 0 1 .443 1.543 2.647 2.647 0 0 1-.545 1.7 3.181 3.181 0 0 1-1.466 1 2.625 2.625 0 0 1 1.623 1.013Zm-6.017-1.789h2.4a2.307 2.307 0 0 0 1.491-.435 1.516 1.516 0 0 0 .537-1.252 1.548 1.548 0 0 0-.537-1.253 2.25 2.25 0 0 0-1.491-.451h-2.4Zm4.175 4.806a1.649 1.649 0 0 0 .563-1.329 1.725 1.725 0 0 0-.6-1.38 2.352 2.352 0 0 0-1.585-.511h-2.557v3.7h2.624a2.324 2.324 0 0 0 1.555-.48Z",
    transform: "translate(-157.409 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19081",
    d: "M314.266 288.388v11.846h-1.942v-5.181h-5.574v5.181h-1.942v-11.846h1.942v5.079h5.574v-5.079Z",
    transform: "translate(-181.022 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19082",
    d: "M353.972 297.805h-4.96l-.853 2.42h-2.028l4.244-11.862h2.25l4.244 11.862h-2.045Zm-.546-1.585-1.926-5.506-1.943 5.506Z",
    transform: "translate(-194.669 -194.858)",
    fill: "url(#banner-title-mobile_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19083",
    d: "M389.183 291.091a5.767 5.767 0 0 1 2.2-2.157 6.467 6.467 0 0 1 6.408.153 5.291 5.291 0 0 1 2.139 2.634h-2.335a3.131 3.131 0 0 0-1.278-1.4 3.8 3.8 0 0 0-1.892-.459 4.134 4.134 0 0 0-2.1.528 3.676 3.676 0 0 0-1.44 1.517 5.352 5.352 0 0 0 0 4.6 3.735 3.735 0 0 0 1.44 1.526 4.086 4.086 0 0 0 2.1.537 3.8 3.8 0 0 0 1.892-.461 3.13 3.13 0 0 0 1.278-1.4h2.335a5.24 5.24 0 0 1-2.139 2.624 6.224 6.224 0 0 1-3.366.92 6.121 6.121 0 0 1-3.051-.775 5.79 5.79 0 0 1-2.19-2.156 6.411 6.411 0 0 1 0-6.238Z",
    transform: "translate(-208.618 -194.791)",
    fill: "url(#banner-title-mobile_svg__f)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19084",
    d: "m439.966 300.234-4.585-5.3v5.3h-1.943v-11.846h1.943v5.4l4.6-5.4h2.437l-5.147 5.931 5.232 5.914Z",
    transform: "translate(-223.5 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19085",
    d: "M480.772 297.805h-4.96l-.853 2.42h-2.028l4.244-11.862h2.25l4.244 11.862h-2.045Zm-.546-1.585-1.926-5.506-1.943 5.506Z",
    transform: "translate(-236.542 -194.858)",
    fill: "url(#banner-title-mobile_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19086",
    d: "M523.49 288.388v1.585h-3.153v10.26h-1.943v-10.26h-3.17v-1.585Z",
    transform: "translate(-250.508 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19087",
    d: "M564.38 288.388v11.846h-1.943v-5.181h-5.573v5.181h-1.943v-11.846h1.943v5.079h5.573v-5.079Z",
    transform: "translate(-263.617 -194.866)",
    fill: "url(#banner-title-mobile_svg__c)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19088",
    d: "M599.33 299.5a5.749 5.749 0 0 1-2.2-2.165 6.426 6.426 0 0 1 0-6.246 5.77 5.77 0 0 1 2.2-2.157 6.393 6.393 0 0 1 6.1 0 5.7 5.7 0 0 1 2.19 2.157 6.488 6.488 0 0 1 0 6.246 5.682 5.682 0 0 1-2.19 2.165 6.388 6.388 0 0 1-6.1 0Zm5.139-1.448a3.726 3.726 0 0 0 1.44-1.535 4.931 4.931 0 0 0 .52-2.309 4.878 4.878 0 0 0-.52-2.3 3.681 3.681 0 0 0-1.44-1.517 4.427 4.427 0 0 0-4.193 0 3.672 3.672 0 0 0-1.44 1.517 4.869 4.869 0 0 0-.52 2.3 4.922 4.922 0 0 0 .52 2.309 3.717 3.717 0 0 0 1.44 1.535 4.364 4.364 0 0 0 4.193 0Z",
    transform: "translate(-277.289 -194.791)",
    fill: "url(#banner-title-mobile_svg__g)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19089",
    d: "M651.4 300.225h-1.943l-5.846-8.845v8.845h-1.943v-11.862h1.943l5.846 8.829v-8.829h1.943Z",
    transform: "translate(-292.263 -194.858)",
    fill: "url(#banner-title-mobile_svg__e)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19090",
    d: "M716.1 297.18q1.637-1.415 2.583-2.327a10.489 10.489 0 0 0 1.577-1.9 3.655 3.655 0 0 0 .63-1.976 2.422 2.422 0 0 0-.486-1.6 1.883 1.883 0 0 0-1.525-.579 1.953 1.953 0 0 0-1.56.639 2.659 2.659 0 0 0-.588 1.713h-1.875a4.173 4.173 0 0 1 6.911-2.982 3.634 3.634 0 0 1 1.048 2.727 4.843 4.843 0 0 1-.622 2.36 9.53 9.53 0 0 1-1.483 2.028q-.861.9-2.19 2.071l-.767.682h5.4v1.619h-8.283v-1.414Z",
    transform: "translate(-316.431 -194.454)",
    fill: "url(#banner-title-mobile_svg__h)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19091",
    d: "M755.214 288.854a4.379 4.379 0 0 1 6.868 0 8.973 8.973 0 0 1 1 4.611 9.146 9.146 0 0 1-1 4.661 4.351 4.351 0 0 1-6.868 0 9.152 9.152 0 0 1-1-4.661 8.98 8.98 0 0 1 1-4.611Zm5.778 2.276a3.132 3.132 0 0 0-.725-1.559 2.468 2.468 0 0 0-3.238 0 3.131 3.131 0 0 0-.724 1.559 12.927 12.927 0 0 0-.179 2.335 14.2 14.2 0 0 0 .17 2.4 3 3 0 0 0 .724 1.568 2.518 2.518 0 0 0 3.256 0 3.005 3.005 0 0 0 .724-1.568 14.2 14.2 0 0 0 .171-2.4 12.937 12.937 0 0 0-.179-2.335Z",
    transform: "translate(-329.431 -194.471)",
    fill: "url(#banner-title-mobile_svg__i)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19092",
    d: "M795.947 297.18q1.637-1.415 2.583-2.327a10.466 10.466 0 0 0 1.577-1.9 3.655 3.655 0 0 0 .63-1.976 2.423 2.423 0 0 0-.486-1.6 1.882 1.882 0 0 0-1.525-.579 1.953 1.953 0 0 0-1.56.639 2.658 2.658 0 0 0-.588 1.713H794.7a4.173 4.173 0 0 1 6.911-2.982 3.634 3.634 0 0 1 1.048 2.727 4.843 4.843 0 0 1-.622 2.36 9.507 9.507 0 0 1-1.483 2.028q-.861.9-2.19 2.071l-.767.682H803v1.619h-8.28v-1.414Z",
    transform: "translate(-342.8 -194.454)",
    fill: "url(#banner-title-mobile_svg__h)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19093",
    d: "M833.687 289.3v-1.773h3.545v12.425h-1.96V289.3Z",
    transform: "translate(-355.674 -194.58)",
    fill: "url(#banner-title-mobile_svg__j)"
  })), /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7662"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19094",
    d: "M127.932 153.149v1.189h-3.054v10.014h-1.463v-10.014h-3.07v-1.189Z",
    transform: "translate(-120.107 -150.206)",
    fill: "url(#banner-title-mobile_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19095",
    d: "M144.177 153.317a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.03 1.03 0 0 1 0 1.415.917.917 0 0 1-.683.289.962.962 0 0 1-.707-.293Zm1.415 1.719v8.809h-1.463v-8.809Z",
    transform: "translate(-127.882 -149.699)",
    fill: "url(#banner-title-mobile_svg__l)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19096",
    d: "M166.7 153.832a4.8 4.8 0 0 1 2.058 1.953 6.589 6.589 0 0 1 0 5.972 4.718 4.718 0 0 1-2.058 1.929 7.057 7.057 0 0 1-3.175.667h-3.485v-11.2h3.488a6.917 6.917 0 0 1 3.172.679Zm.137 8.166a4.375 4.375 0 0 0 1.141-3.223 4.465 4.465 0 0 0-1.149-3.264 4.419 4.419 0 0 0-3.3-1.173H161.5v8.809h2.025a4.466 4.466 0 0 0 3.314-1.147Z",
    transform: "translate(-133.215 -150.206)",
    fill: "url(#banner-title-mobile_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19097",
    d: "M193.623 159.08a2.924 2.924 0 0 1 .8 1 2.9 2.9 0 0 1-.137 2.8 2.95 2.95 0 0 1-1.262 1.078 4.509 4.509 0 0 1-1.953.394H186.9v-11.2h4.019a4.548 4.548 0 0 1 1.945.378 2.753 2.753 0 0 1 1.206 1.021 2.677 2.677 0 0 1 .4 1.446 2.5 2.5 0 0 1-.538 1.648 3.018 3.018 0 0 1-1.423.94 2.374 2.374 0 0 1 1.114.495Zm-5.264-1.093h2.459a2.375 2.375 0 0 0 1.591-.482 1.863 1.863 0 0 0 0-2.668 2.425 2.425 0 0 0-1.624-.482h-2.427Zm4.292 4.645a1.766 1.766 0 0 0 .611-1.43 1.819 1.819 0 0 0-.643-1.471 2.6 2.6 0 0 0-1.72-.538h-2.54v3.954h2.588a2.566 2.566 0 0 0 1.704-.515Z",
    transform: "translate(-142.084 -150.206)",
    fill: "url(#banner-title-mobile_svg__k)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19098",
    d: "M240.522 161h-14.194v-1.061h6.478V158.5h-5.16v-.981h5.16V156.2h-4.887v-5.5h10.947v5.5h-4.886v1.318h5.192v.981h-5.192v1.447h6.542Zm-14.179 3.311a7.144 7.144 0 0 0 1.785-2.668l1.141.273a8.406 8.406 0 0 1-1.816 2.926Zm6.463-9.132v-3.471h-3.745v3.471Zm-2.058-3.07a8.4 8.4 0 0 1 1.045 2.347l-.836.322a9.638 9.638 0 0 0-1-2.4Zm1.222 9.854a12.285 12.285 0 0 1 .354 2.557l-1.173.161a15.287 15.287 0 0 0-.289-2.637Zm5.707-10.255h-3.7v3.471h3.7Zm-2.411 10.143a14.933 14.933 0 0 1 .916 2.54l-1.173.289a18.733 18.733 0 0 0-.852-2.6Zm-.563-7.217a16.824 16.824 0 0 0 1.238-2.54l.932.354c-.45.868-.981 1.865-1.4 2.508Zm3.778 7.009a15.214 15.214 0 0 1 2.122 2.7l-1.158.45a16.228 16.228 0 0 0-2.041-2.782Z",
    transform: "translate(-155.106 -149.397)",
    fill: "url(#banner-title-mobile_svg__m)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19099",
    d: "M271.535 154.208a11.026 11.026 0 0 1-3.2 3.071 21.14 21.14 0 0 0 6.221 1.7 5.288 5.288 0 0 0-.756 1.126 17.29 17.29 0 0 1-2.235-.451v4.726h-1.206v-.514h-6.349v.53h-1.158v-4.662c-.852.258-1.7.45-2.54.627a4.447 4.447 0 0 0-.579-1.045 23.953 23.953 0 0 0 6.318-2.009 11.829 11.829 0 0 1-2.106-1.849 14.5 14.5 0 0 1-2.508 1.559 3.672 3.672 0 0 0-.8-.852 10.722 10.722 0 0 0 4.565-3.6l1.287.226c-.225.321-.482.626-.739.948h4.774l.209-.048Zm-9.967-.015H260.4v-3.023h6.4c-.226-.418-.482-.9-.723-1.286l1.157-.29a15.66 15.66 0 0 1 .932 1.576h5.723v3.023h-1.206v-1.914h-11.115Zm9.388 5.305a19.525 19.525 0 0 1-3.794-1.528 20.961 20.961 0 0 1-3.585 1.528Zm-.595 3.343v-2.331h-6.349v2.331Zm-5.578-8.086a10.122 10.122 0 0 0 2.4 1.945 11.215 11.215 0 0 0 2.524-2.009h-4.855Z",
    transform: "translate(-166.138 -149.032)",
    fill: "url(#banner-title-mobile_svg__n)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19100",
    d: "M304.569 161.588h-10.417v-1.141h10.417Zm3.311-4.212s-.016.386-.048.563c-.37 4.179-.723 5.836-1.35 6.447a1.679 1.679 0 0 1-1.286.514 22.9 22.9 0 0 1-2.524-.031 2.781 2.781 0 0 0-.369-1.157c1.029.1 2.057.113 2.459.113a1.007 1.007 0 0 0 .707-.177c.466-.418.8-1.833 1.125-5.16h-10.256c.193-1.287.4-3.376.514-4.936l1.173.08c-.1 1.173-.241 2.589-.37 3.746h6.238c.209-1.624.418-3.585.563-5h-9.083v-1.157h9.292l.193-.064.868.1a132.377 132.377 0 0 1-.643 6.124Z",
    transform: "translate(-177.503 -149.548)",
    fill: "url(#banner-title-mobile_svg__o)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19101",
    d: "M332.873 157.9c-.627.193-1.238.386-1.849.563v4.582c0 .659-.145.948-.547 1.141a4.611 4.611 0 0 1-1.961.208 4.965 4.965 0 0 0-.354-1.076c.643.016 1.254.016 1.415 0 .209 0 .289-.065.289-.29V158.8l-1.849.547-.338-1.157c.611-.145 1.366-.354 2.186-.579v-3.52h-1.977v-1.11h1.977v-3.231h1.157v3.231h1.688v1.11h-1.688v3.209l1.7-.5Zm9.532 4.71v1.142h-9.774v-1.142h5.434a62.313 62.313 0 0 0 1.511-7.957l1.27.225c-.434 2.475-1.077 5.61-1.672 7.732Zm-.418-8.842h-8.6v-1.125h8.6Zm-6.414 8.1a61.189 61.189 0 0 0-1.094-6.849l1.045-.225a60.529 60.529 0 0 1 1.206 6.736Zm1.543-9.4a17.957 17.957 0 0 0-.772-2.556l1.125-.289a20.963 20.963 0 0 1 .8 2.492Z",
    transform: "translate(-188.575 -149.04)",
    fill: "url(#banner-title-mobile_svg__p)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19102",
    d: "M366.5 159.095c-.257-.595-.836-1.656-1.35-2.54v7.91h-1.173v-7.524a18.051 18.051 0 0 1-2.009 4.581 6.882 6.882 0 0 0-.66-1.157 16.817 16.817 0 0 0 2.54-6.061h-2.3v-1.126h2.428v-3.392h1.173v3.392h1.993v1.122h-1.993v.643c.547.723 1.881 2.684 2.17 3.167Zm4.2-8.552a17.1 17.1 0 0 1-2.782 6.51 9.162 9.162 0 0 0-1.045-.707 13.791 13.791 0 0 0 2.6-6.013Zm2.829 8.343a29.873 29.873 0 0 1 2.234 4.743l-1.093.514a11.357 11.357 0 0 0-.434-1.2c-5.353.707-6.061.82-6.511 1.045h-.025v-.064c-.1-.274-.289-.82-.434-1.142.354-.1.659-.626 1.045-1.415a34.37 34.37 0 0 0 2.4-6.43l1.238.466a41.687 41.687 0 0 1-2.846 7.057l4.711-.563c-.4-.883-.836-1.8-1.27-2.588Zm-.177-8.729a15.729 15.729 0 0 0 2.717 5.884 3.929 3.929 0 0 0-.948.981 18.5 18.5 0 0 1-2.893-6.607Z",
    transform: "translate(-199.678 -149.096)",
    fill: "url(#banner-title-mobile_svg__q)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19103",
    d: "M421.788 148.755v16.076h-.675v-16.076Z",
    transform: "translate(-219.43 -148.755)",
    fill: "url(#banner-title-mobile_svg__r)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19104",
    d: "M463.19 160.177a12.955 12.955 0 0 0 1.954-2.2 3.967 3.967 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.851 2.851 0 0 0-.65 1.825h-1.416a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.367 11.367 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.043-1.639 3.201-2.693Z",
    transform: "translate(-232.269 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19105",
    d: "M484.844 153.812a3.957 3.957 0 0 1 6.284 0 8.64 8.64 0 0 1 .9 4.315 8.808 8.808 0 0 1-.9 4.373 3.946 3.946 0 0 1-6.284 0 8.8 8.8 0 0 1-.9-4.373 8.632 8.632 0 0 1 .9-4.315Zm5.554 1.944a3.028 3.028 0 0 0-.756-1.567 2.605 2.605 0 0 0-3.312 0 3.018 3.018 0 0 0-.756 1.567 12.952 12.952 0 0 0-.185 2.371 13.39 13.39 0 0 0 .185 2.427 3.022 3.022 0 0 0 .756 1.576 2.6 2.6 0 0 0 3.312 0 3.031 3.031 0 0 0 .756-1.576 13.452 13.452 0 0 0 .184-2.427 13.012 13.012 0 0 0-.182-2.371Z",
    transform: "translate(-240.178 -149.912)",
    fill: "url(#banner-title-mobile_svg__t)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19106",
    d: "M511.838 160.177a12.954 12.954 0 0 0 1.953-2.2 3.968 3.968 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.017 2.017 0 0 0-1.632-.6 2.144 2.144 0 0 0-1.7.682 2.852 2.852 0 0 0-.651 1.825h-1.415a3.864 3.864 0 0 1 1.093-2.782 4.152 4.152 0 0 1 5.281-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.367 11.367 0 0 1-1.808 2.219q-1.013.956-2.588 2.226h5.53v1.221h-7.732v-1.051q2.044-1.639 3.202-2.693Z",
    transform: "translate(-248.333 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19107",
    d: "M532.015 153.858v-1.333h3.022v11.622h-1.479v-10.289Z",
    transform: "translate(-256.053 -150)",
    fill: "url(#banner-title-mobile_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19108",
    d: "M550.016 168.749a1 1 0 0 1 .707-1.7.916.916 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.916.916 0 0 1-.683.289.962.962 0 0 1-.707-.293Z",
    transform: "translate(-261.902 -154.795)",
    fill: "url(#banner-title-mobile_svg__v)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19109",
    d: "M564.511 153.858v-1.333h3.021v11.622h-1.479v-10.289Z",
    transform: "translate(-266.784 -150)",
    fill: "url(#banner-title-mobile_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19110",
    d: "M585.589 160.177a12.946 12.946 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.486 2.486 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.847 2.847 0 0 0-.65 1.825h-1.415a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.368 11.368 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.529v1.221h-7.731v-1.051q2.043-1.639 3.201-2.693Z",
    transform: "translate(-272.688 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19111",
    d: "M606.2 168.749a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.03 1.03 0 0 1 0 1.415.917.917 0 0 1-.683.289.961.961 0 0 1-.707-.293Z",
    transform: "translate(-280.455 -154.795)",
    fill: "url(#banner-title-mobile_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19112",
    d: "M623.985 162.332a2.365 2.365 0 0 0 1.583.5 2.141 2.141 0 0 0 1.969-1.046 6.979 6.979 0 0 0 .6-3.52 2.428 2.428 0 0 1-1.125 1.134 3.739 3.739 0 0 1-1.752.41 4.086 4.086 0 0 1-1.921-.442 3.209 3.209 0 0 1-1.326-1.295 4.113 4.113 0 0 1-.482-2.057 3.87 3.87 0 0 1 1-2.774 3.711 3.711 0 0 1 2.829-1.053 3.419 3.419 0 0 1 3.159 1.463 8.38 8.38 0 0 1 .908 4.356 12.909 12.909 0 0 1-.362 3.344 3.762 3.762 0 0 1-1.222 2.009 3.662 3.662 0 0 1-2.355.691 3.529 3.529 0 0 1-2.556-.884 3.469 3.469 0 0 1-1.045-2.251h1.35a2.3 2.3 0 0 0 .748 1.415Zm3.287-4.429a2.394 2.394 0 0 0 .691-1.808 2.772 2.772 0 0 0-.675-1.944 2.439 2.439 0 0 0-1.9-.74 2.347 2.347 0 0 0-1.792.708 2.606 2.606 0 0 0-.667 1.864 2.649 2.649 0 0 0 .659 1.881 2.487 2.487 0 0 0 1.913.707 2.439 2.439 0 0 0 1.771-.671Z",
    transform: "translate(-285.614 -149.889)",
    fill: "url(#banner-title-mobile_svg__x)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19113",
    d: "M668.892 160.157v1.238h-6.414v-1.238Z",
    transform: "translate(-299.136 -152.52)",
    fill: "url(#banner-title-mobile_svg__y)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19114",
    d: "M704.917 160.177a12.978 12.978 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.146 2.146 0 0 0-1.7.682 2.852 2.852 0 0 0-.65 1.825h-1.415a3.862 3.862 0 0 1 1.094-2.782 4.152 4.152 0 0 1 5.281-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.39 11.39 0 0 1-1.808 2.219q-1.013.956-2.588 2.226h5.53v1.221h-7.732v-1.051q2.041-1.639 3.2-2.693Z",
    transform: "translate(-312.094 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19115",
    d: "M726.57 153.812a3.957 3.957 0 0 1 6.284 0 8.64 8.64 0 0 1 .9 4.315 8.807 8.807 0 0 1-.9 4.373 3.946 3.946 0 0 1-6.284 0 8.8 8.8 0 0 1-.9-4.373 8.632 8.632 0 0 1 .9-4.315Zm5.554 1.944a3.019 3.019 0 0 0-.756-1.567 2.6 2.6 0 0 0-3.312 0 3.019 3.019 0 0 0-.756 1.567 12.962 12.962 0 0 0-.184 2.371 13.4 13.4 0 0 0 .184 2.427 3.023 3.023 0 0 0 .756 1.576 2.6 2.6 0 0 0 3.312 0 3.022 3.022 0 0 0 .756-1.576 13.45 13.45 0 0 0 .184-2.427 13.01 13.01 0 0 0-.185-2.371Z",
    transform: "translate(-320.003 -149.912)",
    fill: "url(#banner-title-mobile_svg__t)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19116",
    d: "M753.565 160.177a12.976 12.976 0 0 0 1.953-2.2 3.967 3.967 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.146 2.146 0 0 0-1.7.682 2.851 2.851 0 0 0-.65 1.825h-1.415a3.861 3.861 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .973 2.523 4.808 4.808 0 0 1-.8 2.6 11.366 11.366 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.042-1.639 3.201-2.693Z",
    transform: "translate(-328.159 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19117",
    d: "M777.253 160.177a12.973 12.973 0 0 0 1.953-2.2 3.966 3.966 0 0 0 .8-2.258 2.482 2.482 0 0 0-.506-1.648 2.018 2.018 0 0 0-1.632-.6 2.145 2.145 0 0 0-1.7.682 2.852 2.852 0 0 0-.65 1.825H774.1a3.862 3.862 0 0 1 1.094-2.782 4.151 4.151 0 0 1 5.28-.064 3.3 3.3 0 0 1 .972 2.523 4.807 4.807 0 0 1-.8 2.6 11.366 11.366 0 0 1-1.809 2.219q-1.012.956-2.587 2.226h5.53v1.221h-7.732v-1.051q2.046-1.639 3.205-2.693Z",
    transform: "translate(-335.981 -149.897)",
    fill: "url(#banner-title-mobile_svg__s)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19118",
    d: "M797.863 168.749a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.917.917 0 0 1-.683.289.962.962 0 0 1-.707-.293Z",
    transform: "translate(-343.748 -154.795)",
    fill: "url(#banner-title-mobile_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19119",
    d: "M812.357 153.858v-1.333h3.022v11.622H813.9v-10.289Z",
    transform: "translate(-348.63 -150)",
    fill: "url(#banner-title-mobile_svg__u)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19120",
    d: "M830.358 168.749a1 1 0 0 1 .707-1.7.917.917 0 0 1 .683.289 1.031 1.031 0 0 1 0 1.415.917.917 0 0 1-.683.289.961.961 0 0 1-.707-.293Z",
    transform: "translate(-354.479 -154.795)",
    fill: "url(#banner-title-mobile_svg__w)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19121",
    d: "M848.144 162.332a2.366 2.366 0 0 0 1.583.5 2.141 2.141 0 0 0 1.969-1.046 6.987 6.987 0 0 0 .6-3.52 2.427 2.427 0 0 1-1.125 1.134 3.738 3.738 0 0 1-1.752.41 4.086 4.086 0 0 1-1.921-.442 3.21 3.21 0 0 1-1.326-1.295 4.112 4.112 0 0 1-.482-2.057 3.867 3.867 0 0 1 1-2.774 3.711 3.711 0 0 1 2.829-1.053 3.419 3.419 0 0 1 3.159 1.463 8.379 8.379 0 0 1 .908 4.356 12.912 12.912 0 0 1-.362 3.344A3.764 3.764 0 0 1 852 163.36a3.661 3.661 0 0 1-2.355.691 3.529 3.529 0 0 1-2.556-.884 3.468 3.468 0 0 1-1.045-2.251h1.35a2.3 2.3 0 0 0 .75 1.416Zm3.287-4.429a2.394 2.394 0 0 0 .691-1.808 2.771 2.771 0 0 0-.675-1.944 2.44 2.44 0 0 0-1.9-.74 2.346 2.346 0 0 0-1.792.708 2.606 2.606 0 0 0-.667 1.864 2.649 2.649 0 0 0 .659 1.881 2.487 2.487 0 0 0 1.913.707 2.439 2.439 0 0 0 1.771-.671Z",
    transform: "translate(-359.638 -149.889)",
    fill: "url(#banner-title-mobile_svg__x)"
  }))))));
};
/* harmony default export */ var banner_title_mobile = (SvgBannerTitleMobile);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/faq-collapse.svg
var faq_collapse_g;
function faq_collapse_extends() { faq_collapse_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return faq_collapse_extends.apply(this, arguments); }

var SvgFaqCollapse = function SvgFaqCollapse(props) {
  return /*#__PURE__*/react.createElement("svg", faq_collapse_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), faq_collapse_g || (faq_collapse_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 4808"
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 2279",
    fill: "#84fcfc"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u692D\\u5706 73",
    d: "M14.001 1a13 13 0 0 0-9.192 22.192A13 13 0 0 0 23.193 4.808 12.915 12.915 0 0 0 14.001 1m0-1a14 14 0 1 1-14 14 14 14 0 0 1 14-14Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 5024",
    d: "M19.634 15H8.989v-1h10.645Z"
  })))));
};
/* harmony default export */ var faq_collapse = (SvgFaqCollapse);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/faq-expand.svg
var faq_expand_g;
function faq_expand_extends() { faq_expand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return faq_expand_extends.apply(this, arguments); }

var SvgFaqExpand = function SvgFaqExpand(props) {
  return /*#__PURE__*/react.createElement("svg", faq_expand_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), faq_expand_g || (faq_expand_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 4809",
    fill: "#84fcfc"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 15146",
    d: "M14.817 13.112V7.856h-1.632v5.256H7.953v1.632h5.232V20h1.632v-5.256h5.232v-1.632Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 15145",
    d: "M14 1a13 13 0 0 0-9.192 22.192A13 13 0 0 0 23.192 4.808 12.915 12.915 0 0 0 14 1m0-1A14 14 0 1 1 0 14 14 14 0 0 1 14 0Z"
  }))));
};
/* harmony default export */ var faq_expand = (SvgFaqExpand);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/index.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        "%;\n  padding-right: ",
        "%;\n\n  @media only screen and (max-width: 768px) {\n    padding-left: 22px;\n    padding-right: 22px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  // horizontal paddings are 1/14 of the page width\n  ",
        ";\n  padding-bottom: 3rem;\n  padding-top: 3rem;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  // align the svg on the center\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: -1;\n  height: 3rem;\n  width: 3rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  margin-bottom: 4rem;\n  position: relative;\n  z-index: 2;\n\n  // center the title, background is an image\n  text-align: center;\n  background-image: url(",
        ");\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1em;\n  font-weight: 300;\n  opacity: 0.4;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 4rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n  background: url(",
        ") no-repeat\n    center center;\n  // center background image\n  background-size: cover;\n  height: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding-top: 3rem;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 8rem;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: min(35rem, 100%);\n  margin-bottom: 4rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  width: min(30rem, 100%);\n  margin-bottom: 4rem;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(100% - 44px) !important;\n          position: absolute;\n          bottom: 1rem;\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n          width: min(24rem, 100%);\n          margin-bottom: 4rem;\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 6rem;\n  height: 2.4rem !important;\n  background: #9d9d9d !important;\n  cursor: not-allowed;\n  .ant-click-animating-node {\n    display: none;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  display: flex;\n  align-items: center;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  // qrcode image as background\n  margin: 0 auto;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  color: white;\n  padding-top: 1rem;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  width: 256px;\n  height: 256px;\n  background: url('",
        "') no-repeat center center;\n  background-size: contain;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n\n  &:hover {\n    color: #84fcfc;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      text-align: center;\n      ",
        ";\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        " + ",
        " {\n    border-left: solid 1px white;\n    padding-left: 1rem;\n  }\n\n  ",
        ":not(:last-child) {\n    padding-right: 1rem;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n          width: 50%;\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n          width: 25%;\n        "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  height: 1px;\n  margin-left: auto;\n  margin-right: auto;\n  background-image: linear-gradient(to bottom, #84fcfc 0%, #674ff0 100%); /* the gradient */\n  background-origin: border-box; /* set background to start from border-box */\n  border-spacing: 20px; /* space between each cell */\n  border: 0.1px solid transparent; /* optional */\n  table-layout: fixed;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 2rem;\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  margin-left: min(8rem, 10%);\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  //height: 16rem !important;\n  height: 100%;\n  text-align: start;\n  //padding: 1rem;\n  background-color: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n  height: 4rem !important;\n  justify-content: space-between;\n  background-color: ",
        ";\n  display: flex;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #333333;\n  padding: 1rem;\n  padding-top: calc(1rem + 8px);\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  position: relative;\n  text-align: left;\n  height: 100%;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  height: 8px;\n  top: 0;\n  width: 100%;\n  position: absolute;\n  background-image: linear-gradient(to right, #84fcfc 0%, #674ff0 100%); /* the gradient */\n  background-origin: border-box; /* set background to start from border-box */\n  border-spacing: 20px; /* space between each cell */\n  border: 0.1px solid transparent; /* optional */\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #84fcfc;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-top: 0.5rem;\n  font-size: 14px;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: 14px;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  color: #84fcfc;\n  width: 100%;\n  text-decoration: none;\n\n  &:hover {\n    color: #674ff0;\n  }\n\n  text-align: right;\n  // fix to the end of the card\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n          max-width: ",
        "%;\n        "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n          &:first-child {\n            padding-right: 1rem;\n            position: relative;\n          }\n\n          &:not(:last-child) {\n            &:after {\n              display: block;\n              position: absolute;\n              bottom: -1rem;\n              right: -1rem;\n              z-index: 2;\n              content: url(",
        ");\n            }\n          }\n\n          margin-bottom: 2rem;\n          width: 50%;\n        "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: start;\n  //height: 30rem;\n  ",
        "\n}\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20.596px;\n  z-index: 1;\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position: center;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n\n  ",
        ":first-child {\n    display: none;\n  }\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n          //margin-top: 1rem;\n          padding: 0 0.5rem;\n          border: 1px solid transparent;\n          &:hover {\n            border: 1px solid #84fcfc;\n          }\n        "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n          &:hover {\n            color: #674ff0;\n          }\n        "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: #84fcfc;\n  text-decoration: none;\n\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 3rem;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "px;\n          height: ",
        "px;\n        "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n          height: 322px;\n          width: 282px;\n        "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 auto;\n\n  ",
        "\n  background-image: url(",
        ");\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: contain;\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: ",
        ";\n          padding-top: ",
        ";\n        "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: 14px;\n          padding-top: 30%;\n        "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  font-weight: 300;\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 15%;\n  font-size: 16px;\n  font-weight: 300;\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: 16px;\n        "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: 20px;\n        "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 0;\n  height: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 3rem;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 3rem;\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n  color: #84fcfc;\n  text-align: left;\n  font-size: 20px;\n  line-height: 4rem;\n  font-weight: 300;\n  ",
        "\n  width: fit-content;\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n  // padding\n  padding: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  background: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n  // gradient border\n  background-image: linear-gradient(to right, #84fcfc 0%, #674ff0 100%); /* the gradient */\n  background-origin: border-box; /* set background to start from border-box */\n  border-spacing: 20px; /* space between each cell */\n  border: 0.1px solid transparent; /* optional */\n  margin-bottom: 2rem;\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n  height: 3rem;\n  width: 3rem;\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  color: #84fcfc;\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(0.5 * (100vw - 44px - 2rem));\n          height: calc(0.625 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n          height: ",
        "vw;\n        "
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 300;\n  position: absolute;\n  bottom: 2rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  ",
        "\n  background-color: rgba(36, 35, 106, 0.5);\n  padding: 1rem;\n  text-align: start;\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(0.5 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n        "
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  overflow: hidden;\n  // ellipsis\n  text-overflow: ellipsis;\n\n  bottom: 2rem;\n  // background is a gradient from left to right with diminishing opacity\n  background-image: linear-gradient(to right, rgba(36, 35, 106, 1) 0%, rgba(36, 35, 106, 0) 100%); /* the gradient */\n  //height: 6rem;\n  ",
        "\n  text-align: start;\n  padding: 0.5rem;\n  padding-left: 1rem;\n"
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  font-weight: 300;\n  color: #fff;\n"
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 300;\n  color: #fff;\n"
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(0.5 * (100vw - 44px - 2rem));\n          height: calc(0.625 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n          height: ",
        "vw;\n        "
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(0.5 * (100vw - 44px - 2rem));\n          height: calc(0.625 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n          height: ",
        "vw;\n        "
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  margin-bottom: 2rem;\n  // padding\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  object-fit: cover;\n\n  ",
        " {\n    display: none;\n  }\n\n  &:hover,\n  &:active {\n    ",
        " {\n      display: block;\n    }\n\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n  color: #84fcfc;\n  width: 100%;\n  text-align: left;\n  font-size: 20px;\n  font-weight: 300;\n  margin-bottom: 3rem;\n\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n\n  &:not(:first-child) {\n    margin-top: 3rem;\n  }\n\n  hr {\n    border: 1px dashed #674ff0;\n    width: 90%;\n    padding-left: 1rem;\n  }\n\n  div {\n    width: 3rem;\n  }\n"
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 60rem;\n  // center horizontally\n  margin: 0 auto;\n"
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 2rem;\n"
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 2rem;\n"
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n\n  .ant-collapse-header {\n    padding: 0;\n    height: 3rem;\n    line-height: 3rem;\n    color: #ffffff !important;\n    font-size: 16px;\n    text-align: left;\n    border-bottom: 0.1px dashed #84fcfc;\n  }\n"
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n\n  .ant-collapse-content-box {\n    // vertically center the text\n    display: flex;\n    align-items: center;\n    text-align: left;\n    color: #fff;\n  }\n"
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  padding-top: 3rem;\n  color: #84fcfc;\n  align-items: center;\n\n  &:hover {\n    color: #674ff0;\n  }\n\n  &:after {\n    display: block;\n    content: url(",
        ");\n    height: 24px;\n    width: 24px;\n\n    &:hover {\n      color: #674ff0;\n    }\n  }\n"
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "\n  .slick-slide {\n    padding-right: 0;\n  }\n\n  .slick-dots {\n    margin: 0 auto;\n    bottom: -32px;\n\n    li {\n      margin: 3px 8px;\n\n      &,\n      button {\n        ",
        "\n      }\n\n      &.slick-active {\n        &,\n        button {\n          ",
        "\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex !important;\n  position: relative;\n\n  .ant-image {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n"
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _taggedTemplateLiteral([
        "\n  color: white;\n  font-size: 1rem;\n"
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 2em;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n\n  img {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _taggedTemplateLiteral([
        "\n  background: white;\n  color: black;\n"
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(1.04 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n        "
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  overflow: hidden;\n  // ellipsis\n  text-overflow: ellipsis;\n\n  bottom: 2rem;\n  // background is a gradient from left to right with diminishing opacity\n  background: rgb(0, 0, 0, 75%); /* the gradient */\n  //height: 6rem;\n  ",
        "\n  text-align: start;\n  padding: 0.5rem;\n  padding-left: 1rem;\n"
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  font-weight: 300;\n  color: #fff;\n"
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(1.04 * (100vw - 44px - 2rem));\n          height: calc(0.5942857143 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n          height: ",
        "vw;\n        "
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto 0;\n\n  margin-bottom: 2rem;\n  // padding\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  object-fit: cover;\n  cursor: pointer;\n"
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 300;\n  position: absolute;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 1rem;\n  text-align: start;\n"
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _taggedTemplateLiteral([
        "\n  bottom: 0;\n"
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 1rem;\n  margin: auto 0;\n  position: relative;\n\n  // padding\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  object-fit: cover;\n  cursor: pointer;\n\n  &:hover {\n    ",
        " {\n      display: none;\n    }\n\n    .winner-card-overlay {\n      display: block !important;\n    }\n  }\n"
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 2rem;\n  padding-bottom: 3rem;\n"
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #291f6b;\n  color: white;\n  text-align: left;\n  margin-bottom: 1rem;\n  margin-top: 3rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 1.2rem;\n"
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _taggedTemplateLiteral([
        "\n          width: calc(1.04 * (100vw - 44px - 2rem));\n        "
    ]);
    _templateObject104 = function _templateObject104() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _taggedTemplateLiteral([
        "\n          width: ",
        "vw;\n        "
    ]);
    _templateObject105 = function _templateObject105() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject106() {
        return data;
    };
    return data;
}










var columnWidth = 7.5;
var backgroundColor = "#191821";
var textColor = "#fff";
var getImage = function(name) {
    return  true ? "".concat("https://img1.tidb.net", "/images/hackathon/").concat(name) : 0;
};
var horizontalPadding = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), columnWidth, columnWidth);
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), backgroundColor, textColor);
var Section = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), horizontalPadding, function(props) {
    return !props.leftAlign && "text-align: center;";
});
var SectionTitleBackground = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3(), JSON.stringify(ball.src));
var SectionTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), SectionTitleBackground);
var SectionFooter = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var BannerWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var Banner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), function(props) {
    return getImage(props.isSmallScreen ? "banner-bg-mobile.jpg" : "banner-bg.jpg");
}, function(props) {
    return props.isSmallScreen ? "calc(100vh - 84px)" : "32rem";
});
var BannerContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
}, horizontalPadding);
var BannerTitle = (0,styled_components_browser_esm/* default */.ZP)(banner_title)(_templateObject10());
var BannerTitleMobile = (0,styled_components_browser_esm/* default */.ZP)(banner_title_mobile)(_templateObject11());
var BannerButtonsGroup = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), function(props) {
    return props.isSmallScreen ? (0,styled_components_browser_esm/* css */.iv)(_templateObject12()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
});
var BannerButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary",
    size: "small"
})(_templateObject15());
var BannerQRCodeOverlay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16());
var BannerQRCodeContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17());
var BannerQRCodeText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject18());
var BannerQRCodeImage = styled_components_browser_esm/* default.div */.ZP.div(_templateObject19(), getImage("banner-qrcode.jpg"));
var BannerNavButton = styled_components_browser_esm/* default.a */.ZP.a(_templateObject20());
var BannerNavButtonsGroup = styled_components_browser_esm/* default.div */.ZP.div(_templateObject22(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), horizontalPadding);
}, BannerNavButton, BannerNavButton, BannerNavButton);
var TableCell = styled_components_browser_esm/* default.td */.ZP.td(_templateObject25(), function(props) {
    return props.isSmallScreen ? (0,styled_components_browser_esm/* css */.iv)(_templateObject23()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject24());
});
var TableHeaderCell = (0,styled_components_browser_esm/* default */.ZP)(TableCell)(_templateObject26());
var Table = styled_components_browser_esm/* default.table */.ZP.table(_templateObject27());
var TableHeaderIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject28(), function(props) {
    return props.src;
});
var TableCellContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject29(), backgroundColor);
var TableCellContentInner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject30());
var TableHeaderCellContent = (0,styled_components_browser_esm/* default */.ZP)(TableCellContent)(_templateObject31(), backgroundColor);
var ProcedureCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject32());
var ProcedureCardGradientSlice = styled_components_browser_esm/* default.div */.ZP.div(_templateObject33());
var ProcedureCardTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject34());
var ProcedureCardDate = styled_components_browser_esm/* default.div */.ZP.div(_templateObject35());
var ProcedureCardDescription = styled_components_browser_esm/* default.div */.ZP.div(_templateObject36());
var ProcedureCardButton = (0,styled_components_browser_esm/* default */.ZP)(components/* Link */.rU)(_templateObject37());
var ProcedureCardWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject40(), function(props) {
    return !props.isSmallScreen ? (0,styled_components_browser_esm/* css */.iv)(_templateObject38(), columnWidth * 2) : (0,styled_components_browser_esm/* css */.iv)(_templateObject39(), getImage("procedure-card-divider-mobile.svg"));
});
var ProcedureCardDivider = styled_components_browser_esm/* default.div */.ZP.div(_templateObject41(), getImage("procedure-card-divider.svg"));
var ProcedureCardsGroup = styled_components_browser_esm/* default.div */.ZP.div(_templateObject42(), ProcedureCardDivider);
var Link = (0,styled_components_browser_esm/* default */.ZP)(components/* Link */.rU)(_templateObject45(), function(props) {
    return props.fontSize || "14px";
}, function(props) {
    return props.border ? (0,styled_components_browser_esm/* css */.iv)(_templateObject43()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject44());
});
var LocationSpan = styled_components_browser_esm/* default.div */.ZP.div(_templateObject46());
var Prize = styled_components_browser_esm/* default.div */.ZP.div(_templateObject49(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject47(), 282 * 0.5, 322 * 0.5) : (0,styled_components_browser_esm/* css */.iv)(_templateObject48());
}, function(props) {
    return props.src;
});
var PrizeTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject52(), function(props1) {
    return props1.huge ? (0,styled_components_browser_esm/* css */.iv)(_templateObject50(), function(props) {
        return props.sm ? "1.2rem" : "1.5rem";
    }, props1.sm ? "12%" : "20%") : (0,styled_components_browser_esm/* css */.iv)(_templateObject51());
});
var PrizeCount = styled_components_browser_esm/* default.div */.ZP.div(_templateObject53());
var PrizeReward = styled_components_browser_esm/* default.div */.ZP.div(_templateObject56(), function(props) {
    return props.sm ? "0.5rem" : "1rem";
}, function(props) {
    return props.tiny ? (0,styled_components_browser_esm/* css */.iv)(_templateObject54()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject55());
});
var PrizesRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject57());
var GlowLabel = styled_components_browser_esm/* default.div */.ZP.div(_templateObject59(), function(props) {
    return props.tall && (0,styled_components_browser_esm/* css */.iv)(_templateObject58());
}, getImage("prizes-label-bg.svg"));
var BenefitCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject60(), backgroundColor);
var BenefitCardWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject61());
var BenefitCardIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject62(), function(props) {
    return props.src;
});
var BenefitCardContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject63());
var JudgeCardOverlay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject66(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject64()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject65(), columnWidth * 2, columnWidth * 2.5);
});
var JudgeCardContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject69(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject67()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject68(), columnWidth * 2);
});
var JudgeCardName = styled_components_browser_esm/* default.div */.ZP.div(_templateObject70());
var JudgeCardDescription = styled_components_browser_esm/* default.div */.ZP.div(_templateObject71());
var DummyJudgeCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject74(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject72()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject73(), columnWidth * 2, columnWidth * 2.5);
});
var JudgeCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject77(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject75()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject76(), columnWidth * 2, columnWidth * 2.5);
}, function(props) {
    return props.src;
}, JudgeCardOverlay, JudgeCardOverlay, JudgeCardContent);
var JudgesLabel = styled_components_browser_esm/* default.div */.ZP.div(_templateObject78());
var FAQWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject79());
var CollapseIcon = (0,styled_components_browser_esm/* default */.ZP)(faq_collapse)(_templateObject80());
var ExpandIcon = (0,styled_components_browser_esm/* default */.ZP)(faq_expand)(_templateObject81());
var FAQCollapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs({
    defaultActiveKey: [
        "1"
    ],
    expandIconPosition: "right",
    expandIcon: function(param) {
        var isActive = param.isActive;
        return isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon, {});
    },
    ghost: true,
    accordion: true
})(_templateObject82(), backgroundColor);
var FAQCollapsePanel = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default.Panel */.Z.Panel)(_templateObject83(), backgroundColor);
var FAQButton = styled_components_browser_esm/* default.a */.ZP.a(_templateObject84(), getImage("faq-arrow-right.svg"));
var Carousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).attrs({
    dotPosition: "bottom"
})(_templateObject85(), mixins/* size */.dp("40px", "6px"), mixins/* size */.dp("50px", "6px"));
var CarouselInner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject86());
var CarouselDescription = styled_components_browser_esm/* default.div */.ZP.div(_templateObject87());
var CarouselContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject88(), function(props) {
    return props.width;
});
var LogoWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject89());
var PartnerSection = (0,styled_components_browser_esm/* default */.ZP)(Section)(_templateObject90());
var NewsCardContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject93(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject91()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject92(), columnWidth * 3 * 1.2);
});
var NewsCardTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject94());
var DummyNewsCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject97(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject95()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject96(), columnWidth * 3 * 1.2, columnWidth * 1.7142857143 * 1.2);
});
var NewsCard = (0,styled_components_browser_esm/* default */.ZP)(DummyNewsCard)(_templateObject98(), function(props) {
    return props.src;
});
var WinnerCardOverlay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject99());
var WinnerCardContent = (0,styled_components_browser_esm/* default */.ZP)(NewsCardContent)(_templateObject100());
var WinnerCard = (0,styled_components_browser_esm/* default */.ZP)(DummyNewsCard)(_templateObject101(), function(props) {
    return props.src;
}, WinnerCardContent);
var WinnerRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject102());
var FinalistCard = (0,styled_components_browser_esm/* default */.ZP)(DummyNewsCard)(_templateObject103());
var FinalistRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject106(), function(props) {
    return props.sm ? (0,styled_components_browser_esm/* css */.iv)(_templateObject104()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject105(), columnWidth * 3 * 1.2);
});

;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/datasource.js



var seo = {
    title: "TiDB Hackathon 2021",
    description: "\u672C\u6B21 Hackathon \u4E3B\u9898\u4E3A\u300CExplore the Sky\u300D\uFF0C\u5C3D\u60C5\u53D1\u6325\u5929\u9A6C\u884C\u7A7A\u7684\u60F3\u8C61\uFF0C\u7528 TiDB \u521B\u9020\u65E0\u9650\u53EF\u80FD\u3002",
    keywords: [
        "\u9ED1\u5BA2\u9A6C\u62C9\u677E",
        "TiDB",
        "Hackathon"
    ]
};
var groupsData = [
    {
        name: "\u5185\u6838\u7EC4",
        desc: "\u4E3A TiDB\u3001TiKV\u3001PD \u6027\u80FD\u3001\u7A33\u5B9A\u6027\u3001\u6613\u7528\u6027\u6216\u529F\u80FD\u7B49\u5404\u65B9\u9762\u505A\u51FA\u63D0\u5347\uFF0C\u4E5F\u53EF\u4EE5\u6784\u5EFA\u4E91\u539F\u751F\u65F6\u4EE3\u7684 TiDB \u5185\u6838\u7B49\u3002"
    },
    {
        name: "\u5DE5\u5177\u7EC4",
        desc: "\u5BF9 TiDB \u90E8\u7F72\u8FD0\u7EF4\u3001\u6570\u636E\u6D41\u8F6C\uFF08\u6570\u636E\u8FC1\u79FB\u3001\u6570\u636E\u590D\u5236\u3001\u5168\u91CF\u5BFC\u5165\u5BFC\u51FA\uFF09\u3001\u96C6\u7FA4\u5BB9\u707E\u3001\u8BCA\u65AD\u548C\u53EF\u89C6\u5316\u7B49\u914D\u5957\u5DE5\u5177\u7684\u4F18\u5316\u6216\u65B0\u521B\u610F\u3002"
    },
    {
        name: "\u751F\u6001\u7EC4",
        desc: "\u4E30\u5BCC TiDB/TiKV/TiDB Cloud \u5E94\u7528\u751F\u6001\uFF0C\u8865\u5145\u548C\u589E\u5F3A\u4E0A\u4E0B\u6E38\u5DE5\u5177\u3001\u5E73\u53F0\u3001\u5E94\u7528\u5BF9 TiDB/TiKV/TiDB Cloud \u7684\u652F\u6301\u80FD\u529B\uFF0C\u4F8B\u5982\u589E\u5F3A MySQL \u751F\u6001\u4E2D\u95F4\u4EF6\u3001\u5E94\u7528\u6846\u67B6\u5BF9 TiDB \u7684\u517C\u5BB9\u6027\uFF0C\u57FA\u4E8E TiDB Cloud \u7684\u4E91\u4E0A\u5E94\u7528\u5F00\u53D1\u7B49\u3002"
    },
    {
        name: "\u221E",
        desc: "\u6B22\u8FCE\u5176\u4ED6\u4EFB\u4F55 Cool idea\uFF0C\u521B\u9020\u4E0D\u8BBE\u9650\uFF01\n PS. Chaos Mesh \u7231\u597D\u8005\u770B\u8FC7\u6765"
    }, 
];
var stepsData = [
    {
        title: 'STEP 1intro: "\u63D0\u4EA4\u62A5\u540D',
        date: "\u622A\u81F3 12 \u6708 27 \u65E5",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "\u62A5\u540D\u5F00\u59CB\uFF0C\u53EA\u8981\u4F60\u5BF9 coding \u611F\u5174\u8DA3\uFF0C\u90FD\u53EF\u4EE5\u62A5\u540D\u53C2\u52A0\uFF0C\u70B9\u51FB",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273502",
                    children: "\u67E5\u770B\u53C2\u8D5B\u6307\u5357\u3002"
                })
            ]
        }),
        action: "\u7ACB\u5373\u62A5\u540D",
        url: "https://forms.pingcap.com/f/TiDBHackathon2021apply"
    },
    {
        title: 'STEP 2intro: "\u5B8C\u6210\u7EC4\u961F',
        date: "\u62A5\u540D\u540E - 12 \u6708 28 \u65E5",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "\u62A5\u540D\u6210\u529F\u5373\u53EF\u542F\u52A8\u7EC4\u961F\uFF0C\u627E\u5230\u4F60\u559C\u6B22\u7684\u961F\u53CB\u7EC4\u6210\u6218\u961F\uFF0C\u9009\u62D4\u961F\u957F\uFF0C\u62DF\u5B9A\u961F\u540D\uFF0C\u63D0\u4EA4\u56E2\u961F RFC"
        }),
        action: "\u63D0\u4EA4 RFC",
        url: "https://forms.pingcap.com/f/TiDBHackathon2021RFC"
    },
    {
        title: 'STEP 3intro: "\u8D5B\u524D\u51C6\u5907',
        date: "\u622A\u81F3 1 \u6708 7 \u65E5\uFF08\u5171 10 \u5929\uFF09",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "\u6211\u4EEC\u7ED9\u4F60\u51C6\u5907\u4E86\u5145\u5206\u7684",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273503",
                    children: "\u5B66\u4E60\u8D44\u6599"
                }),
                "\uFF0C\u4E13\u4E1A\u5BFC\u5E08\u7FA4\u5185\u7B54\u7591\u7B49\uFF0C\u8BA9\u4F60\u5B66\u4E60\u65E0\u969C\u788D\u3002"
            ]
        }),
        action: "\u67E5\u770B\u5B66\u4E60\u8D44\u6599",
        url: "https://pingkai.cn/tidbcommunity/forum/t/topic/273503"
    },
    {
        title: 'STEP 4intro: "\u9884\u8D5B\u7B54\u8FA9',
        date: "1 \u6708 8 \u65E5\uFF08\u5468\u516D\uFF09",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "\u5317\u4EAC\u3001\u4E0A\u6D77\u3001\u676D\u5DDE\u3001\u6210\u90FD\u3001\u6DF1\u5733\u3001\u5E7F\u5DDE\u4EFB\u9009\u4E00\u5904\u51B3\u8D5B\u53C2\u8D5B\u70B9\uFF0C\u8FD8\u53EF\u4EE5\u8D70\u8FDB PingCAP Office \u611F\u53D7 P \u793E\u6587\u5316\u3002"
        }),
        action: "\u4E0B\u8F7D\u7B54\u8FA9 PPT \u6A21\u677F",
        url: "https://pingkai.cn/tidbcommunity/forum/t/topic/273653"
    },
    {
        title: 'STEP 5intro: "\u51B3\u8D5B\u7B54\u8FA9&\u9881\u5956',
        date: "1 \u6708 9 \u65E5\uFF08\u5468\u65E5\uFF09",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "\u51B3\u8D5B\u73B0\u573A\u5982\u706B\u5982\u837C\uFF0C\u4F17\u591A\u5956\u9879\u7B49\u4F60\u62FF\uFF01"
        })
    }, 
];
var FAQData = [
    {
        q: "1. \u6BCF\u652F\u53C2\u8D5B\u961F\u4F0D\u6700\u591A\u51E0\u4E2A\u4EBA\uFF1F",
        a: "\u56E2\u961F\u53C2\u8D5B\u6700\u591A 4 \u4EBA\u4E3A\u4E00\u4E2A\u5C0F\u7EC4\u3002\u5355\u4EBA\u53C2\u8D5B\u4E5F\u652F\u6301\u54E6\uFF5E"
    },
    {
        q: "2. \u4E3B\u529E\u65B9\u63D0\u4F9B\u9910\u996E\u548C\u4F4F\u5BBF\u5417\uFF1F",
        a: "\u6211\u4EEC\u63D0\u4F9B\u53C2\u8D5B\u8005\u548C\u5FD7\u613F\u8005\u6BD4\u8D5B\u671F\u95F4\u7684\u9910\u996E\uFF08\u4E24\u4EFD\u5348\u9910\u3001\u4E00\u4EFD\u65E9\u9910\u3001\u4E24\u4EFD\u665A\u9910\uFF09\uFF0C\u53C2\u8D5B\u9009\u624B\u53EF\u7559\u5728\u6BD4\u8D5B\u573A\u5730\u8FC7\u591C\uFF0C\u5982\u9700\u5728\u573A\u5730\u9644\u8FD1\u79DF\u4F4F\u5BBE\u9986\u8BF7\u81EA\u884C\u89E3\u51B3\uFF5E"
    },
    {
        q: "3. \u6BD4\u8D5B\u4F1A\u7531\u4E8E\u75AB\u60C5\u53D6\u6D88\u5417\uFF1F",
        a: "\u6211\u4EEC\u4F1A\u5BC6\u5207\u5173\u6CE8\u75AB\u60C5\u52A8\u5411\uFF0C\u5982\u6709\u4E0D\u53EF\u6297\u529B\u5219\u6BD4\u8D5B\u4F1A\u6539\u4E3A\u5168\u7A0B\u7EBF\u4E0A\uFF0C\u4E0D\u4F1A\u53D6\u6D88\u54E6\uFF5E"
    },
    {
        q: "4. \u4F1A\u573A\u5206\u522B\u5728\u54EA\u4E9B\u57CE\u5E02\uFF1F",
        a: "\u4E0A\u6D77\u3001\u5317\u4EAC\u3001\u676D\u5DDE\u3001\u5E7F\u5DDE\u3001\u6210\u90FD\u3001\u6DF1\u5733"
    },
    {
        q: "5. \u4EC0\u4E48\u65F6\u5019\u53EF\u4EE5\u5F00\u59CB\u7F16\u5199\u4EE3\u7801\uFF1F",
        a: "\u7EC4\u961F\u5B8C\u6210\u540E\u5C31\u53EF\u4EE5\u5F00\u59CB\u7F16\u5199\u4EE3\u7801\u4E86\uFF01\u5982\u679C\u9047\u5230\u5B66\u4E60\u8D44\u6599\u4E2D\u5C1A\u672A\u89E3\u7B54\u7684\u95EE\u9898\uFF0C\u53EF\u4EE5\u52A0\u5165Hackathon 2021 \u53C2\u8D5B\u7FA4\uFF0C\u7FA4\u5185\u5C06\u6709\u5BFC\u5E08\u4E0D\u5B9A\u671F\u7EBF\u4E0A\u7B54\u7591\uFF0C\u4EE5\u53CA\u96C6\u4E2D\u76F4\u64AD\u5206\u4EAB\u3002"
    },
    {
        q: "6. \u6821\u56ED\u56E2\u961F\u5956\u53C2\u4E0E\u8BC4\u9009\u7684\u4EBA\u7FA4\u662F\uFF1F",
        a: '\u8BE5\u56E2\u961F\u9700\u8981\u5168\u5458\u7686\u4E3Aintro: "\u672A\u6BD5\u4E1A\u5927\u5B66\u751F\u3001\u7855\u58EB\u3001\u535A\u58EB\u3002'
    }, 
];
var judgesData = [
    {
        name: "\u9648\u8083",
        desc: "DataPipeline CTO",
        detail: "\u9648\u8083\uFF0C2010 \u5E74\u83B7\u4E2D\u56FD\u79D1\u5B66\u9662\u7814\u7A76\u751F\u9662\u8F6F\u4EF6\u7406\u8BBA\u535A\u58EB\u5B66\u4F4D\u540E\u52A0\u5165\u4E2D\u56FD\u79FB\u52A8\u7814\u7A76\u9662\u7528\u6237\u884C\u4E3A\u5B9E\u9A8C\u5BA4\uFF0C\u5386\u4EFB\u7B97\u6CD5\u5DE5\u7A0B\u5E08\u3001\u9879\u76EE\u7ECF\u7406\u3001\u5B9E\u9A8C\u5BA4\u6280\u672F\u8D1F\u8D23\u4EBA\u30022015 \u52A0\u5165\u4EBF\u745E\u4E92\u52A8\u79D1\u6280\uFF08\u5317\u4EAC\uFF09\u6709\u9650\u516C\u53F8\u4EFB\u6280\u672F VP\uFF0C\u8D1F\u8D23\u5927\u540E\u7AEF+\u81EA\u9002\u5E94\u5B66\u4E60\u7CFB\u7EDF\u7684\u7814\u53D1\u5DE5\u4F5C\u30022017 \u5E74\u4EE5\u5408\u4F19\u4EBA\u8EAB\u4EFD\u52A0\u5165 DataPipeline \u4EFB CTO\uFF0C\u8D1F\u8D23\u516C\u53F8\u7684\u4EA7\u54C1\u6280\u672F\u7814\u53D1\u5DE5\u4F5C\u3002"
    },
    {
        name: "\u9648\u6631",
        desc: "\u4E91\u542F\u8D44\u672C\u5408\u4F19\u4EBA",
        detail: "\u91CD\u70B9\u5173\u6CE8\u5927\u6570\u636E\u3001\u4E91\u8BA1\u7B97\u3001\u667A\u80FD\u9A7E\u9A76\u548C\u673A\u5668\u4EBA\u7B49\u9886\u57DF\u7684\u6295\u8D44\u3002\u4E3B\u5BFC\u6295\u8D44\u4E86 PingCAP\u3001Zilliz\u3001Jina AI\u3001Singularity\u3001TigerGraph\u3001Graviti\u3001Cloudchef\u3001\u5143\u620E\u542F\u884C\u3001\u64CE\u6717\u667A\u80FD\u3001\u667A\u9F7F\u79D1\u6280\u3001\u5FB7\u98CE\u79D1\u6280\u3001\u65B0\u77F3\u5668\u3001\u6570\u777F\u6570\u636E\u3001\u8FFD\u52BF\u79D1\u6280\u548C\u6BD4\u74F4\u79D1\u6280\u7B49\u4F18\u79C0\u4F01\u4E1A\u3002"
    },
    {
        name: "\u4EE3\u95FB",
        desc: "PingCAP TiDB Cloud \u8D1F\u8D23\u4EBA",
        detail: "\u8D1F\u8D23 TiDB Cloud \u4EA7\u54C1\u548C\u4E1A\u52A1\uFF0C\u5728\u5927\u89C4\u6A21\u540E\u53F0\u67B6\u6784\u3001\u7269\u8054\u7F51\u5E94\u7528\u3001\u5A92\u4F53\u884C\u4E1A\u8F6C\u578B\u3001\u4F01\u4E1A\u6DF7\u5408IT\u548C\u81EA\u52A8\u5316\u8FD0\u7EF4\u7B49\u65B9\u9762\u6709\u4E30\u5BCC\u7ECF\u9A8C\u3002"
    },
    {
        name: "\u51AF\u5149\u666E",
        desc: "\u591A\u70B9 Dmall \u6570\u636E\u5E93\u56E2\u961F\u8D1F\u8D23\u4EBA",
        detail: "\u66FE\u5728\u963F\u91CC\u5DF4\u5DF4\u6570\u636E\u5E93\u56E2\u961F\uFF0C\u8D1F\u8D23 AliSQL \u5206\u652F\u7EF4\u62A4\u3001\u7279\u6027\u5F00\u53D1\u53CA Bugfix\uFF0C\u76EE\u524D\u662F\u6570\u5B57\u5316\u96F6\u552E\u591A\u70B9 Dmall \u6570\u636E\u5E93\u8D1F\u8D23\u4EBA\uFF0C\u4E3B\u8981\u8D1F\u8D23\u5927\u89C4\u6A21 MySQL\u3001Redis\u3001TiDB\u3001MongoDB \u7B49\u6570\u636E\u5E93\u96C6\u7FA4\u7684\u5B89\u5168\u7A33\u5B9A\u9AD8\u6548\uFF0CDB PaaS \u5E73\u53F0\u5EFA\u8BBE\uFF0C\u4EE5\u53CA\u540C\u57CE\u53CC\u6D3B/\u5F02\u5730\u591A\u6D3B\u6570\u636E\u5E93\u6574\u4F53\u67B6\u6784\u53CA\u6570\u636E\u540C\u6B65\u65B9\u6848\u843D\u5730\u3002"
    },
    {
        name: "\u5173\u80DC\u4EAE",
        desc: "\u6D9B\u601D\u6570\u636E\u8054\u5408\u521B\u59CB\u4EBA\u517C\u6280\u672F VP",
        detail: "\u5173\u80DC\u4EAE\uFF0C\u6D9B\u601D\u6570\u636E\u8054\u5408\u521B\u59CB\u4EBA\u517C\u6280\u672F VP\u3002\u65F6\u5E8F\u6570\u636E\u5E93 TDengine \u7684\u4E3B\u8981\u5F00\u53D1\u8005\u4E4B\u4E00\u3002\u5177\u6709\u8D85\u8FC710\u5E74\u7684\u6280\u672F\u5F00\u53D1\u4E0E\u7814\u53D1\u7BA1\u7406\u7ECF\u9A8C\uFF0C\u4E00\u76F4\u4E13\u6CE8\u5728\u65F6\u5E8F\u6570\u636E\u5B58\u50A8\u9886\u57DF\uFF0C\u76EE\u524D\u4E13\u6CE8\u4E8E\u9AD8\u53EF\u7528\u96C6\u7FA4\u3001\u9AD8\u6548\u6570\u636E\u5199\u5165\u3001\u5B9E\u65F6\u6570\u636E\u8BA2\u9605\u7B49\u6280\u672F\u65B9\u5411\u3002\u5728\u52A0\u5165\u6D9B\u601D\u6570\u636E\u4E4B\u524D\uFF0C\u5148\u540E\u5C31\u804C\u4E8E\u56FD\u5BB6\u7535\u7F51\u3001360 \u7B49\u516C\u53F8\u3002"
    },
    {
        name: "\u90ED\u709C",
        desc: "Apache Foundation Member",
        detail: "Apache Foundation Member, Apache IPMC Member\n Apache Dolphin Scheduler PMC\uFF0CClickHouse \u534E\u4EBA\u793E\u533A\u521B\u59CB\u4EBA\uFF0C\u4E2D\u56FD 2021 \u5E74\u5F00\u6E90\u6770\u51FA\u4EBA\u7269\u3002\n \u90ED\u709C\u5148\u751F\u6BD5\u4E1A\u4E8E\u5317\u4EAC\u5927\u5B66\uFF0C\u5148\u540E\u5728\u4E2D\u91D1\u3001IBM\u3001Teradata \u4EFB\u5927\u6570\u636E\u65B9\u91CD\u8981\u804C\u4F4D\uFF0C\u5BF9\u5927\u6570\u636E\u524D\u6CBF\u7814\u7A76\u505A\u51FA\u5353\u8D8A\u8D21\u732E\u3002"
    },
    {
        name: "\u8D3A\u519B",
        desc: "\u5EFA\u4FE1\u91D1\u79D1\u57FA\u7840\u6280\u672F\u4E2D\u5FC3\u67B6\u6784\u5E08",
        detail: "\u66FE\u5728 IBM \u4E2D\u56FD\u7CFB\u7EDF\u79D1\u6280\u5B9E\u9A8C\u5BA4\u3001\u5FAE\u8F6F\u4E9A\u6D32\u5DE5\u7A0B\u9662\u641C\u7D22\u6280\u672F\u4E2D\u5FC3\u548C\u963F\u91CC\u5DF4\u5DF4\u963F\u91CC\u4E91\u667A\u80FD\u7B49\u4F01\u4E1A\u90E8\u95E8\u5DE5\u4F5C\u3002\u4E00\u76F4\u5728\u5F00\u6E90\u7CFB\u7EDF\u8F6F\u4EF6\u3001\u6570\u636E\u5E93\u3001\u9AD8\u6027\u80FD\u8BA1\u7B97\u3001\u4E91\u8BA1\u7B97\u3001\u5927\u6570\u636E\u7B49\u5206\u5E03\u5F0F\u7CFB\u7EDF\u9886\u57DF\u4ECE\u4E8B\u76F8\u5173\u6280\u672F\u5DE5\u4F5C\uFF0C\u53C2\u4E0E\u4E86\u4F17\u591A\u4F01\u4E1A\u7EA7\u7CFB\u7EDF\u8F6F\u4EF6\u6280\u672F\u7814\u53D1\u548C\u4EA7\u54C1\u521B\u65B0\u7684\u5546\u4E1A\u5B9E\u8DF5\u3002"
    },
    {
        name: "\u674E\u51EF",
        desc: "\u7F8E\u56E2\u6570\u636E\u5E93\u7814\u53D1\u4E2D\u5FC3\u8D1F\u8D23\u4EBA",
        detail: "\u6BD5\u4E1A\u4E8E\u5317\u4EAC\u90AE\u7535\u5927\u5B66\uFF0C2007 \u5E74\u81F3\u4ECA\u5148\u540E\u5728\u767E\u5EA6\u3001\u8682\u8681\u3001\u534E\u4E3A\u4ECE\u4E8B\u5206\u5E03\u5F0F\u5B58\u50A8\u548C\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u7684\u7814\u53D1\u548C\u6280\u672F\u7BA1\u7406\u5DE5\u4F5C\uFF0C\u76EE\u524D\u62C5\u4EFB\u7F8E\u56E2\u57FA\u7840\u6280\u672F\u90E8\u6570\u636E\u5E93\u7814\u53D1\u4E2D\u5FC3\u8D1F\u8D23\u4EBA\uFF0C\u56E2\u961F\u4E3B\u8981\u8D1F\u8D23\u7F8E\u56E2\u6570\u636E\u5E93\u8FD0\u7EF4\u3001\u5E73\u53F0\u3001\u4E2D\u95F4\u4EF6\u548C\u81EA\u7814\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u5185\u6838\u7684\u5DE5\u4F5C\u3002"
    },
    {
        name: "\u6F58\u5A1F",
        desc: "SphereEx \u8054\u5408\u521B\u59CB\u4EBA & CTO\uFF0CApache ShardingSphere PMC",
        detail: "SphereEx \u8054\u5408\u521B\u59CB\u4EBA & CTO\uFF0CApache Member & Apache ShardingSphere PMC\uFF0CApache brpc (Incubating) Mentor & Apache AGE (Incubating) Mentor\uFF0CAWS Data Hero\uFF0C\u4E2D\u56FD\u6728\u5170\u5F00\u6E90\u793E\u533A\u5BFC\u5E08\u3002" + "\n \u66FE\u8D1F\u8D23\u4EAC\u4E1C\u6570\u79D1\u6570\u636E\u5E93\u667A\u80FD\u5E73\u53F0\u7684\u8BBE\u8BA1\u4E0E\u7814\u53D1\uFF0C\u73B0\u4E13\u6CE8\u4E8E\u5206\u5E03\u5F0F\u6570\u636E\u5E93 & \u4E2D\u95F4\u4EF6\u751F\u6001\u53CA\u5F00\u6E90\u9886\u57DF\u3002\u88AB\u8BC4\u4E3A\u300A2020 \u4E2D\u56FD\u5F00\u6E90\u5148\u950B\u4EBA\u7269\u300B\uFF0C2021 OSCAR \u5C16\u5CF0\u5F00\u6E90\u4EBA\u7269\u3002"
    },
    {
        name: "\u6F58\u82F1\u8D85",
        desc: "\u5C0F\u7C73\u5927\u6570\u636E\u59D4\u5458\u4F1A\u79D8\u4E66\u957F",
        detail: "\u4E2D\u56FD\u8BA1\u7B97\u673A\u5B66\u4F1A\u5927\u6570\u636E SIG \u8054\u5E2D\u4E3B\u5E2D\uFF0CTGO \u9CB2\u9E4F\u4F1A\u4F1A\u5458\u300214 \u5E74 ICT \u6280\u672F\u53CA\u4EA7\u54C1\u7BA1\u7406\u7ECF\u9A8C\uFF0C\u5148\u540E\u4F9B\u804C\u4E8E\u9510\u6377\u7F51\u7EDC\u3001\u6469\u6258\u7F57\u62C9\u3001\u601D\u79D1\u3001\u5FAE\u8F6F\u3001Quixey\u30012017 \u5E74\u52A0\u5165\u5C0F\u7C73\u3002\u5728\u6570\u5B57\u5316\u8F6C\u578B\u3001\u6570\u636E\u4E2D\u53F0\u3001\u6570\u636E\u6CBB\u7406\u7B49\u9886\u57DF\u6709\u7740\u624E\u5B9E\u7684\u7406\u8BBA\u79EF\u7D2F\u53CA\u4E30\u5BCC\u7684\u5B9E\u8DF5\u7ECF\u9A8C\u3002"
    },
    {
        name: "\u4E54\u6728",
        desc: "Google Cloud Data Management Specialist",
        detail: "\u524D AWS \u6570\u636E\u5E93\u4EE5\u53CA\u5B58\u50A8\u670D\u52A1 Subject Matter Expert\uFF0C\u73B0 Google Cloud \u6570\u636E\u5E93\u670D\u52A1 Specialist\u3002\u5728\u4E91\u8BA1\u7B97\u6570\u636E\u5E93\u7684\u67B6\u6784\u4EE5\u53CA\u4F7F\u7528\u65B9\u9762\u6709\u4E30\u5BCC\u7ECF\u9A8C\u3002"
    },
    {
        name: "\u6C88\u65F8",
        desc: "\u795E\u5DDE\u6570\u7801\u96C6\u56E2\u526F\u603B\u88C1\u517C CIO",
        detail: "\u795E\u5DDE\u6570\u7801\u96C6\u56E2\u80A1\u4EFD\u6709\u9650\u516C\u53F8\u526F\u603B\u88C1\u517C CIO\uFF0C\u4E91\u57FA\u5730\u8D1F\u8D23\u4EBA\uFF0C\u96C6\u56E2\u6280\u672F\u59D4\u5458\u4F1A\u59D4\u5458\u3002\u4E3B\u5BFC\u96C6\u56E2\u6570\u5B57\u5316\u8F6C\u578B\u3001\u6570\u5B57\u4E2D\u53F0\u3001\u8425\u9500\u79C1\u57DF\u8FD0\u8425\u7B49\uFF0C\u9886\u5BFC\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u3001\u5F00\u6E90 ERP\u3001SAAS \u7B49\u9886\u57DF\u7684\u5F00\u53D1\u7BA1\u7406\u5DE5\u4F5C\u3002\u662F\u4FE1\u606F\u6280\u672F\u9886\u57DF\u8D85\u8FC7 12 \u5E74\u7684\u4E13\u4E1A\u6280\u672F\u4E13\u5BB6\u3002"
    },
    {
        name: "\u5510\u5218",
        desc: "VP of Engineering, PingCAP",
        detail: "Chief Engineer, VP of Engineering, First Employee @PingCAP"
    },
    {
        name: "\u5434\u665F",
        desc: "Apache \u8F6F\u4EF6\u57FA\u91D1\u4F1A\u8463\u4E8B\uFF0CTetrate \u521B\u59CB\u5DE5\u7A0B\u5E08",
        detail: "Tetrate \u521B\u59CB\u5DE5\u7A0B\u5E08\uFF0CApache \u8F6F\u4EF6\u57FA\u91D1\u4F1A\u8463\u4E8B\uFF0CApache SkyWalking \u521B\u59CB\u4EBA\u3002"
    },
    {
        name: "\u8C22\u4F73",
        desc: "\u534E\u521B\u8D44\u672C\u5408\u4F19\u4EBA",
        detail: '\u4E13\u6CE8\u4E8E\u4F01\u4E1A\u8F6F\u4EF6\u53CA\u670D\u52A1\u9886\u57DF\u7684\u65E9\u671F\u6295\u8D44\uFF0C2015 \u5E74\u52A0\u5165\u534E\u521B\u8D44\u672C\uFF0C\u7814\u7A76\u9A71\u52A8\u578B\u6295\u8D44\u4EBA\uFF0C\u8986\u76D6\u7684\u9886\u57DF\u5305\u62EC SaaS / Cloud Infra / AI&DataTech / Cybersecurity \u7B49\u3002\u5728\u534E\u521B\u8D44\u672C\u8D1F\u8D23\u63A8\u52A8\u548C\u6267\u884C\u7684\u6295\u8D44\u6848\u4F8B\u5305\u62ECintro: "PingCAP\u3001ONES\u3001\u68A6\u8BDA\u79D1\u6280\u3001\u5929\u65E6\u3001\u4E2D\u777F\u5929\u4E0B\u3001FONE\u3001\u77F3\u58A8\u6587\u6863\u3001JuiceData\u3001\u767E\u89C2\u79D1\u6280\u3001\u5C0F\u6EE1\u79D1\u6280\u7B49\u3002'
    },
    {
        name: "\u5F90\u4E4B\u6D69",
        desc: "\u660E\u52BF\u8D44\u672C\u6267\u884C\u8463\u4E8B",
        detail: "\u5F90\u4E4B\u6D69\u5728\u660E\u52BF\u8D44\u672C\u8D1F\u8D23\u4F01\u4E1A\u670D\u52A1\u3001\u4E91\u8BA1\u7B97\u4E0E\u5F00\u6E90\u8F6F\u4EF6\u3001\u5168\u771F\u4E92\u8054\u7F51\u7B49\u9886\u57DF\uFF0C\u6295\u8D44\u4E86 PingCAP\u3001\u851A\u9886\u65F6\u4EE3\u3001StarRocks\u3001Nothing \u7B49\u521D\u521B\u4F01\u4E1A\u3002\u5728\u52A0\u5165\u6295\u8D44\u884C\u4E1A\u4E4B\u524D\uFF0C\u5F90\u4E4B\u6D69\u6709\u8FD1 10 \u5E74\u7814\u53D1\u5DE5\u4F5C\u7ECF\u5386\uFF0C\u66FE\u4F9B\u804C\u4E8E\u5FAE\u8F6F\u3001\u767E\u5EA6\u3001\u5FAE\u535A\u3001\u4E9A\u9A6C\u900A\u4E91\u670D\u52A1\u7B49\u79D1\u6280\u516C\u53F8\u3002"
    },
    {
        name: "\u6BB7\u6210\u6587",
        desc: "PingCAP \u6DF7\u6C8C\u5DE5\u7A0B\u56E2\u961F\u8D1F\u8D23\u4EBA",
        detail: "PingCAP \u6DF7\u6C8C\u5DE5\u7A0B\u56E2\u961F\u8D1F\u8D23\u4EBA\uFF0CCNCF \u5F00\u6E90\u9879\u76EE Chaos Mesh \u7684\u53D1\u8D77\u4EBA\u548C\u7EF4\u62A4\u8005\u3002\u4E4B\u524D\u4E3B\u8981\u8D1F\u8D23\u5206\u5E03\u5F0F\u6570\u636E\u5E93 TiDB \u7684\u7A33\u5B9A\u6027\u6D4B\u8BD5\u6846\u67B6\u7684\u8BBE\u8BA1\u548C\u5F00\u53D1\u4EFB\u52A1\uFF0C\u76EE\u524D\u81F4\u529B\u4E8E\u63A2\u7D22\u6DF7\u6C8C\u5DE5\u7A0B\u7684\u5B9E\u65BD\u548C\u63A8\u5E7F\u5DE5\u4F5C\u3002\u5F00\u6E90\u7231\u597D\u8005\uFF0C\u201CKubeCon + CloudNativeCon Europe 2021\u201D \u548C \u201CKubeCon + CloudNativeCon North America 2021\u201D \u8BA1\u5212\u59D4\u5458\u4F1A\u6210\u5458\u3002"
    },
    {
        name: "\u4FDE\u52C7",
        desc: "\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66\u7279\u8058\u6559\u6388\u3001\u535A\u58EB\u751F\u5BFC\u5E08\uFF0CACM \u73ED\u521B\u59CB\u4EBA",
        detail: "1986 \u5E74\u5165\u804C\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66\uFF0C\u73B0\u4EFB\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66 ACM \u56FD\u9645\u5927\u5B66\u751F\u7A0B\u5E8F\u8BBE\u8BA1\u7ADE\u8D5B\u603B\u6559\u7EC3\uFF0C\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66\u201C\u6559\u80B2\u90E8\u57FA\u7840\u5B66\u79D1\u62D4\u5C16\u5B66\u751F\u57F9\u517B\u8BA1\u5212\u201D\u8BA1\u7B97\u673A\u5B66\u79D1\uFF08ACM \u73ED\uFF09\u9879\u76EE\u4E3B\u4EFB\uFF0C\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66 APEX \u5B9E\u9A8C\u5BA4\u4E3B\u4EFB\uFF0C\u957F\u671F\u81F4\u529B\u4E8E\u57F9\u517B\u8BA1\u7B97\u673A\u79D1\u5B66\u5BB6\u53CA\u884C\u4E1A\u4EBA\u5458\u3002"
    },
    {
        name: "\u7FDF\u4F73",
        desc: "Apache Pulsar PMC \u6210\u5458\u3001StreamNative \u8054\u5408\u521B\u59CB\u4EBA",
        detail: "\u7FDF\u4F73\u66FE\u4EFB\u804C\u4E8E EMC\uFF0C\u62C5\u4EFB\u7EDF\u4E00\u5B58\u50A8\u90E8\u95E8\u6280\u672F\u8D1F\u8D23\u4EBA\u3002\u4ED6\u4E3B\u8981\u4ECE\u4E8B\u5B9E\u65F6\u8BA1\u7B97\u548C\u5206\u5E03\u5F0F\u5B58\u50A8\u7CFB\u7EDF\u7684\u76F8\u5173\u7814\u7A76\u5DE5\u4F5C\uFF0C\u5728\u5F00\u6E90\u9879\u76EE Apache BookKeeper\u3001Apache Pulsar \u7B49\u9879\u76EE\u4E2D\u6301\u7EED\u8D21\u732E\u4EE3\u7801\uFF0C\u662F\u5F00\u6E90\u9879\u76EE Apache Pulsar \u548C Apache BookKeeper \u7684 PMC \u6210\u5458\u548C Committer\u3002"
    },
    {
        name: "\u7FDF\u7389\u9F99",
        desc: "PingCAP Dataplatform \u56E2\u961F PM",
        detail: "PingCAP \u524D\u8F6F\u4EF6\u5F00\u53D1\u5DE5\u7A0B\u5E08\uFF1B\u73B0 Data Platform \u56E2\u961F PM\uFF0C\u4E1A\u4F59\u65F6\u95F4\u4F1A\u5199\u4EE3\u7801\u7684\u5F00\u6E90\u7231\u597D\u8005\u3002"
    },
    {
        name: "\u5F20\u5EFA",
        desc: "PingCAP \u7814\u53D1\u603B\u76D1",
        detail: "\u5F00\u6E90\u7231\u597D\u8005\uFF0CPingCAP \u7814\u53D1\u603B\u76D1\uFF0C\u524D\u963F\u91CC\u5DF4\u5DF4 ODPS \u6267\u884C\u5F15\u64CE\u7814\u53D1\u5DE5\u7A0B\u5E08\u3002\u5728\u67E5\u8BE2\u4F18\u5316\uFF0C\u5206\u5E03\u5F0F\u8BA1\u7B97\u7B49\u65B9\u9762\u6709\u591A\u5E74\u7684\u7814\u53D1\u7ECF\u9A8C\u30022017 \u5E74\u52A0\u5165 PingCAP \u4ECE\u4E8B TiDB SQL \u5C42\u7684\u4EA7\u54C1\u7814\u53D1\u3001\u67B6\u6784\u6539\u8FDB\u3001TiDB \u793E\u533A\u5EFA\u8BBE\u7B49\uFF0C\u76EE\u524D\u5728\u8D1F\u8D23 TiKV \u7684\u4EA7\u54C1\u7814\u53D1\u4E0E\u6539\u8FDB\u3002"
    },
    {
        name: "\u5F20\u96C1\u98DE",
        desc: "Datafuse Labs \u8054\u5408\u521B\u59CB\u4EBA",
        detail: "\u5F00\u6E90\u72C2\u70ED\u7231\u597D\u8005\uFF0CTokuDB & ClickHouse \u91CD\u5EA6\u8D21\u732E\u8005\uFF0C\u5F00\u6E90 Cloud Warehouse \u9879\u76EE Databend \u53D1\u8D77\u4EBA\u3002"
    }, 
];
var carouselData = [
    {
        img: getImage("prev-20.jpg"),
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2020/",
        desc: "TiDB Hackathon 2020"
    },
    {
        img: getImage("prev-19.jpg"),
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2019/",
        desc: "TiDB Hackathon 2019"
    },
    {
        img: getImage("prev-18.jpg"),
        url: "https://pingkai.cn/tidbcommunity/archived/events/hackathon2018/",
        desc: "TiDB Hackathon 2018"
    }, 
];
var winners = [
    {
        github: "https://github.com/shenzhengcmss/tidb-support-s3",
        intro: "TiDB\u51B7\u70ED\u6570\u636E\u5206\u5C42\u5B58\u50A8\u4E3B\u8981\u8003\u8651\u7684\u662F\u70ED\u6570\u636E\u5B58\u653E\u5728TiKV\u4E0A\u4EE5\u53CA\u5F88\u5C11\u51E0\u7387\u67E5\u8BE2\u5206\u6790\u7684\u51B7\u6570\u636E\u5B58\u653E\u5230\u4FBF\u5B9C\u901A\u7528\u7684\u4E91\u5B58\u50A8S3\u4E0A\uFF0C\u540C\u65F6\u4F7FS3\u5B58\u50A8\u5F15\u64CE\u652F\u6301TiDB\u90E8\u5206\u7B97\u5B50\u4E0B\u63A8\uFF0C\u5B9E\u73B0TiDB\u57FA\u4E8ES3\u51B7\u6570\u636E\u5206\u6790\u67E5\u8BE2\u3002",
        name: "He3",
        prize: "\u4E00\u7B49\u5956\uFFE5100000",
        rfc: "https://github.com/shenzhengcmss/tidb-support-s3/blob/main/TiDB%20%e5%86%b7%e7%83%ad%e6%95%b0%e6%8d%ae%e5%88%86%e5%b1%82%e5%ad%98%e5%82%a8.md",
        video: "https://www.bilibili.com/video/BV1Y44y1L7VZ?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/tigraph/tidb",
        intro: "\u8BED\u6CD5\u5B8C\u5907\u7684\u5206\u5E03\u5F0F\u56FE\u6570\u636E\u5E93\u3002\u5BF92021\u5E74TiGraph\u9879\u76EE\u7684\u4E00\u6B21\u9769\u547D\u6027\u8FDB\u5316\u3002\u5168\u65B0\u7684\u501F\u9274\u81EApgql\u7684\u5B8C\u5907\u8BED\u6CD5\uFF0C\u6570\u636E\u5B58\u50A8\u4E8ETiKV\u5E76\u5B9E\u73B0\u4E86\u7B97\u5B50\u4E0B\u63A8\u3002DDL\u4E0E\u7F16\u89E3\u7801\u65B9\u9762\u5B9E\u73B0\u4E86\u5BF9\u539F\u6709\u7ED3\u6784\u7684\u6781\u5C0F\u4FB5\u5165\u4E0E\u6539\u52A8",
        name: "TiMatch",
        prize: "\u4E8C\u7B49\u5956\uFFE550000",
        rfc: "https://github.com/tigraph/rfc-2022/blob/main/README.md",
        video: "https://www.bilibili.com/video/BV1Wq4y1c7Aj?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/hackathon2021-pCloud",
        intro: "\u7075\u611F\u6765\u81EA\u4E8E iCloud\uFF0C\u5E0C\u671B\u80FD\u968F\u65F6\u968F\u5730\u65B9\u4FBF\u7528\u6237\u5F00\u542F\u5907\u4EFD\u4E0A\u4E91\u7684\u529F\u80FD\uFF0C\u9488\u5BF9\u5907\u4EFD\u9700\u6C42\u6539\u8FDB\u73B0\u6709\u7684\u4ED8\u8D39\u6A21\u5F0F\uFF0C\u5229\u7528\u4E91\u4E0A\u5B58\u50A8\uFF0C\u66F4\u65B9\u4FBF\u5FEB\u6377\u7684\u5B9E\u73B0\u5907\u4EFD\u6062\u590D\u5230\u4EFB\u610F\u65F6\u95F4\u70B9\u7684\u529F\u80FD\u3002",
        name: "pCloud",
        prize: "\u4E8C\u7B49\u5956\uFFE550000, \u6700\u4F73\u5E02\u573A\u6F5C\u529B\uFF08\u4E91\u542F\uFF09\uFFE58000",
        rfc: "https://github.com/hackathon2021-pCloud/pCloud",
        video: "https://www.bilibili.com/video/BV1Kr4y1e7iB?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/TiLaker/tikv-client-java",
        intro: "TiDB \u6570\u636E\u5B9E\u65F6\u5165\u6E56\u5DE5\u5177",
        name: "TiLaker",
        prize: "\u4E8C\u7B49\u5956\uFFE550000, \u6700\u4F73\u5E02\u573A\u6F5C\u529B\uFF08\u534E\u521B\uFF09\uFFE58000 ,\u6700\u4F73\u4EBA\u6C14\u5956 \u7F57\u6280\u952E\u76D8\u4EBA\u624B1\u4E2A",
        rfc: "https://github.com/TiLaker/tilaker",
        video: "https://www.bilibili.com/video/BV1t3411Y7yV?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/Long-Live-the-DoDo",
        intro: "Flashback \u662F\u7528\u4E8E\u5728\u7528\u6237\u53D1\u751F\u8BEF\u64CD\u4F5C\u7684\u65F6\u5019\uFF0C\u5FEB\u901F\u56DE\u6EDA\u81F3\u539F\u5148\u7248\u672C\uFF0C\u907F\u514D\u4EA7\u751F\u91CD\u5927\u635F\u5931\u7684\u7279\u6027\uFF0C\u5F97\u76CA\u4E8E MVCC \u673A\u5236\uFF0C\u6211\u4EEC\u53EF\u4EE5\u8BA9 TiDB \u5728\u67D0\u4E9B\u65B9\u9762\u505A\u7684\u6BD4 Oracle Flashback \u66F4\u5F3A\u5927\uFF01",
        name: "\u6E21\u6E21\u9E1F\u590D\u5174\u4F1A",
        prize: "\u4E09\u7B49\u5956\uFFE520000",
        rfc: "https://github.com/Long-Live-the-DoDo/rfc",
        video: "https://www.bilibili.com/video/BV1ZF411H73L?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/collie-dev",
        intro: "collie diagnosing platform \u96C6 \u6545\u969C\u573A\u666F\u4FE1\u606F\u6536\u96C6 / ui \u5728\u7EBF\u89C2\u5BDF\u5206\u6790 / \u673A\u5668\u5B66\u4E60\u8F85\u52A9\u8BCA\u65AD \u4E8E\u4E00\u8EAB\u7684\u6545\u969C\u8BCA\u65AD\u5206\u6790\u89E3\u51B3\u5E73\u53F0",
        name: "\u6211\u4EEC\u8FD9\u4E48\u83DC\u8BC4\u59D4\u4E0D\u4F1A\u751F\u6C14\u5427",
        prize: "\u4E09\u7B49\u5956\uFFE520000",
        rfc: "https://github.com/WPH95/collie",
        video: "https://www.bilibili.com/video/BV143411Y76Y?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/hackathon2021index/tidb/blob/hackathon5.3/hackathan_rfc.md",
        intro: "\u7528 lightning \u7684\u65B9\u5F0F\u6765\u5B9E\u73B0 \u7D22\u5F15\u76F8\u5173 ddl: \u751F\u6210 sst \u6587\u4EF6\u7136\u540E ingest \u5230 tikv.",
        name: "\u9ED1\u9A6C\u8B66\u957F",
        prize: "\u4E09\u7B49\u5956\uFFE520000",
        rfc: "https://github.com/hackathon2021index/tidb/blob/hackathon5.3/hackathan_rfc.md",
        video: "https://www.bilibili.com/video/BV1KT4y127SP?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/oom-ai/oomstore",
        intro: "oom.ai \u7279\u5F81\u5E73\u53F0\u652F\u6301\u96C6\u6210 TiDB/TiKV \u4F5C\u4E3A\u5B58\u50A8\uFF0C\u8BA9 TiDB \u7684\u7528\u6237\u53EA\u9700\u8FDB\u884C\u7B80\u5355\u7684\u914D\u7F6E\uFF0C\u5373\u53EF\u89E3\u9501\u673A\u5668\u5B66\u4E60\u7279\u5F81\u5E73\u53F0\uFF0C\u4E3A\u6A21\u578B\u63D0\u4F9B\u53EF\u9760\u7684\u6570\u636E\u652F\u6301\u3002",
        name: "oom.ai",
        prize: "\u4E09\u7B49\u5956\uFFE520000",
        rfc: "https://github.com/oom-ai/rfc-tidb-hackathon-2022",
        video: "https://www.bilibili.com/video/BV1XS4y157S5?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/Hackathon-2022-TiVP",
        intro: "TiVP is a Visual Plan for TiDB SQL explaination integreted with Dashboard. \u8BE5\u9879\u76EE\u65E8\u5728\u53EF\u89C6\u5316 TiDB \u751F\u6210\u7684\u6267\u884C\u8BA1\u5212\u3002",
        name: "TiVP",
        prize: "\u4E09\u7B49\u5956\uFFE520000, \u7528\u6237\u4E4B\u9009\u5956\uFFE55000",
        rfc: "https://github.com/yiwen92/Hackathon-2021-TiVP/blob/master/README.md",
        video: "https://www.bilibili.com/video/BV12b4y1J77R?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/TPC-TiKV",
        intro: "Better TiKV!!!",
        name: "TPC",
        prize: "\u4E09\u7B49\u5956\uFFE520000, \u6280\u672F\u6F5C\u529B\u5956\uFFE55000",
        rfc: "https://github.com/TPC-TiKV/rfc",
        video: "https://www.bilibili.com/video/BV1U44y1W7im?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/TiInterstellar/tidb",
        intro: "\u4E3A TiDB \u8BBE\u8BA1\u4E86\u4E00\u4E2A\u65B0\u529F\u80FD\uFF0C\u67D0\u8868\u4F1A\u81EA\u52A8\u5C06\u5386\u53F2\u6570\u636E\u5206\u533A\uFF0C\u5E76\u79FB\u5165\u66F4\u4FBF\u5B9C\u7684\u5BF9\u8C61\u5B58\u50A8\uFF08S3\uFF09\u4E2D\u53BB\u3002\u540C\u65F6\u5BF9\u5916\u7684SQL\u67E5\u8BE2\u63A5\u53E3\u4E0D\u53D8\uFF0C\u4F9D\u7136\u53EF\u4EE5\u540C\u65F6\u67E5\u8BE2\u5230 SSD \u78C1\u76D8\uFF0C\u4E5F\u80FD\u67E5\u8BE2\u5230\u5BF9\u8C61\u5B58\u50A8\u4E2D\u7684\u6570\u636E\u3002",
        name: "Interstellar",
        prize: "\u4E91\u4E0A\u5E94\u7528\uFFE53000",
        rfc: "https://github.com/TiInterstellar/tidb",
        video: ""
    },
    {
        github: "https://github.com/fantastic-things/chaoscraft/blob/main/README.MD",
        intro: "\u5728\u6E38\u620F\u4E2D\u5C55\u793A Kubernetes \u5DE5\u4F5C\u8D1F\u8F7D\u5E76\u8FDB\u884C\u6DF7\u6C8C\u5B9E\u9A8C\u3002",
        name: "\u6ED1\u6ED1\u86CB",
        prize: "\u65E0\u9650\u521B\u610F\uFFE55000",
        rfc: "https://github.com/fantastic-things/chaoscraft/blob/main/README.MD",
        video: "https://www.bilibili.com/video/BV1jP4y177FH?spm_id_from=333.999.0.0"
    },
    {
        github: "https://github.com/PDSL-AI/Tenseigan",
        intro: 'Tenseigan\u662F\u9488\u5BF9 TiDB \u7684\u4E00\u4E2A\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u7684\u8C03\u4F18\u6D4B\u8BD5\u6846\u67B6\uFF0C\u8BE5\u5DE5\u5177\u80FD\u591F\u63D0\u4F9Bintro: "\u81EA\u52A8\u8C03\u53C2\u3001\u53C2\u6570\u5F71\u54CD\u5EA6\u8BC4\u4F30\u7B49\u529F\u80FD\uFF0C\u96C6\u6210\u4E86\u591A\u79CD workload\uFF0C\u652F\u6301 cloud \u548C on-promise \u73AF\u5883\u3002',
        name: "Matrix",
        prize: "\u6700\u4F73\u6821\u56ED\uFFE55000, \u6700\u4F73\u5E02\u573A\u6F5C\u529B\uFF08\u660E\u52BF\uFF09\uFFE58000",
        rfc: "https://github.com/CheneyDing/2021-TiDB-Hackthon-RFC/blob/main/README.md",
        video: "https://www.bilibili.com/video/BV1yq4y1c7NV?spm_id_from=333.999.0.0"
    },
    {
        github: undefined,
        intro: "Gitlab\u5728TiDB\u4E0A\u7684\u7A76\u6781\u517C\u5BB9\uFF01\uFF01\u5B9E\u73B0\u4E00\u4E2A\u517C\u5BB9PG\u534F\u8BAE\u7684TiDB\uFF0C\u517C\u5BB9Gitlab\u3002\u542F\u52A8\u591AGitlab\u5B9E\u4F8B\uFF0C\u770B\u770B\u6362\u4E86\u4E00\u4E2A\u534F\u8BAE\u7684TiDB\u6570\u636E\u5E93\u8FD8\u80FD\u4E0D\u80FD\u6491\u4F4F\uFF01\u6BD4\u4EE5\u524D\u66F4\u5F3A\uFF0C\u8FD8\u662F\u66F4\u5F31\uFF0C\u8BA9\u6211\u4EEC\u62ED\u76EE\u4EE5\u5F85\uFF01",
        name: "TiGi",
        prize: "\u79EF\u5206\u6311\u6218\u5956\uFFE52000",
        rfc: "https://github.com/DigitalChinaOpenSource/TiGi",
        video: undefined
    },
    {
        github: undefined,
        intro: "lotusdb \u662F\u4E00\u4E2A Go \u8BED\u8A00\u5B9E\u73B0\u7684\u5355\u673A kv \u5B58\u50A8\u5F15\u64CE\uFF0C\u5177\u6709\u8BFB\u5199\u901F\u5EA6\u5FEB\u3001\u8BFB\u5199\u653E\u5927\u6781\u4F4E\u7684\u7279\u70B9\u3002 \u6211\u4EEC\u5E0C\u671B\u80FD\u591F\u4F7F lotusdb \u6210\u4E3A TiKV \u4E2D\u9664\u4E86 rocksdb \u4E4B\u5916\u7684\u65B0\u9009\u62E9\u3002",
        name: "lotusdb",
        prize: "\u79EF\u5206\u6311\u6218\u5956\uFFE52000",
        rfc: "https://github.com/flower-corp/lotusdb/blob/main/hackathon-rfc.md",
        video: undefined
    },
    {
        github: undefined,
        intro: "\u6211\u4EEC\u5728\u4F7F\u7528 TiDB \u524D\u7F00\u7D22\u5F15\u8868\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u9488\u5BF9\u6211\u4EEC\u7684\u67E5\u8BE2\uFF0C\u6267\u884C\u6548\u7387\u4E0D\u9AD8\uFF0C\u6211\u4EEC\u9488\u5BF9\u8FD9\u79CD\u67E5\u8BE2\u5C1D\u8BD5\u8FDB\u884C\u4F18\u5316\uFF0C\u5E0C\u671B\u5728\u8FD9\u79CD\u67E5\u8BE2\u4E0B\u80FD\u8FBE\u5230\u666E\u901A\u7D22\u5F15\u7684\u6548\u7387",
        name: "\u6478\u9C7C\u4E0D",
        prize: "\u79EF\u5206\u6311\u6218\u5956\uFFE52000",
        rfc: "https://github.com/jiyfhust/prefix_index/blob/main/RFC.md",
        video: undefined
    },
    {
        github: undefined,
        intro: "TiDelta \u80FD\u5E2E\u52A9\u4F60\u6574\u5408 TiDB \u5173\u952E\u8DEF\u5F84\u7684\u6027\u80FD metrics\uFF0C\u5E76\u751F\u6210 Metrics Diff Report\uFF0C\u65B9\u4FBF\u7528\u6237\u5BF9\u6BD4\u4EFB\u4F55\u4E24\u4E2A\u65F6\u95F4\u6BB5\uFF0C\u6216\u8005\u662F\u5347\u7EA7\u524D\u540E\u3001\u6D4B\u8BD5\u5E93\u548C\u751F\u4EA7\u5E93\u7684\u6027\u80FD\u6307\u6807\u3002",
        name: "TiAlphas",
        prize: "\u6700\u4F73\u4EBA\u6C14\u5956 \u7F57\u6280\u952E\u76D8\u4EBA\u624B1\u4E2A",
        rfc: "https://github.com/Yui-Song/tidelta",
        video: undefined
    }, 
];
var finalists = [
    {
        team: "Bubbles",
        project: "Deploy TiDB on Cloud",
        intro: "\u63D0\u4F9B\u4E00\u4E2A\u53EF\u89C6\u5316\u5E73\u53F0\uFF0C\u5728\u516C\u6709\u4E91\u5E73\u53F0\u4E0A\u5FEB\u901F\u90E8\u7F72TiDB\u3002",
        rfc: "https://github.com/jiayang-zheng/deploy-tidb-on-cloud/blob/main/README.md"
    },
    {
        team: "ChaosMore",
        project: "ChaosMore",
        intro: "\u57FA\u4E8EeBPF \u4E3A ChaosMesh \u8BBE\u8BA1\u81EA\u5B9A\u4E49\u6DF7\u6C8C\u5DE5\u7A0B\u7684\u63D2\u4EF6\u673A\u5236\u548C\u80FD\u529B",
        rfc: "https://github.com/vanx7/chaos-more"
    },
    {
        team: "\u8C6B\u56ED",
        project: "TiMultiple",
        intro: "\u57FA\u4E8ERaft Learner\u548CRaw API\u5B9E\u73B0\u591A\u96C6\u7FA4\u8BFB\u5199\u5206\u79BB\u548C\u5728\u7EBF\u707E\u5907",
        rfc: "https://github.com/lizhenhuan/tikv"
    },
    {
        team: "\u90FD\u6C5F\u5830",
        project: "Dujiang Weir",
        intro: "Weir \u662F\u4F34\u9C7C\u516C\u53F8\u7814\u53D1\u9488\u5BF9 TiDB \u573A\u666F\u7684\u4E03\u5C42\u8D1F\u8F7D\u5747\u8861\u5668\u3002\u540C\u8BB8\u591A\u9762\u5411\u5206\u5E93\u5206\u8868\u7684\u4E03\u5C42\u8D1F\u8F7D\u5747\u8861\u4E0D\u540C\uFF0C\u5B83\u7684\u76EE\u6807\u662F\u4E3A TiDB" + " \u5E26\u6765\u66F4\u5F3A\u7684\u6570\u636E\u5E93\u6CBB\u7406\u80FD\u529B\uFF0C\u4EE5\u975E\u4FB5\u5165\u7684\u65B9\u5F0F\u4E3A TiDB \u63D0\u4F9B\u4E86\u8BB8\u591A\u4E0D\u9002\u5408\u5728\u5185\u6838\u4E2D\u5B9E\u73B0\u7684\u80FD\u529B\u3002\u6211\u4EEC\u76F8\u4FE1\u4E00\u4E2A\u80FD\u591F\u4EE5\u975E\u4FB5\u5165\u65B9\u5F0F\u6A21\u5757\u5316\u6269\u5C55\u7684 Weir \u80FD\u591F\u4E3A\u5B83\u5E26\u6765\u65E0\u7A77\u7684\u6D3B\u529B\uFF0C\u6210\u4E3A\u6574\u4E2A TiDB \u751F\u6001\u80FD\u529B\u6269\u5C55\u7684\u6865\u5934\u5821\u3002",
        rfc: "https://github.com/tidb-hackathon/dujiangyan/blob/main/README.md"
    },
    {
        team: "Ti\u53EF\u7ACB\u523B",
        project: "Ti Click",
        intro: "\u901A\u8FC7\u5728\u7EBFIDE\u7684\u65B9\u5F0F\uFF0C\u5FEB\u901F\u642D\u5EFATiDB\u7684\u53EF\u7F16\u7A0B\u548C\u7F16\u8BD1\u7684\u5728\u7EBF\u5B9E\u9A8C\u5BA4\u3002\u63D0\u9AD8\u7528\u6237\u7684TiDB\u751F\u6001\u7684\u521D\u4F53\u9A8C\u3002 \u6B64\u5916\u8FD8\u53EF\u4EE5\u8BA9\u7528\u6237\u5728\u7EBF\u5C1D\u8BD5\u5305\u62ECTiDB" + " Cloud\u670D\u52A1\u5728\u5185\u7684\u591A\u9879\u670D\u52A1\uFF0C\u964D\u4F4ETiDB\u751F\u6001\u7684\u5C1D\u9C9C\u590D\u6742\u7A0B\u5EA6\u3002",
        rfc: "https://github.com/ti-click/"
    },
    {
        team: "Matrix",
        project: "Tenseigan",
        intro: 'Tenseigan\u662F\u9488\u5BF9 TiDB \u7684\u4E00\u4E2A\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u7684\u8C03\u4F18\u6D4B\u8BD5\u6846\u67B6\uFF0C\u8BE5\u5DE5\u5177\u80FD\u591F\u63D0\u4F9Bintro: "\u81EA\u52A8\u8C03\u53C2\u3001\u53C2\u6570\u5F71\u54CD\u5EA6\u8BC4\u4F30\u7B49\u529F\u80FD\uFF0C\u96C6\u6210\u4E86\u591A\u79CD' + " workload\uFF0C\u652F\u6301 cloud \u548C on-promise \u73AF\u5883\u3002",
        rfc: "https://github.com/CheneyDing/2021-TiDB-Hackthon-RFC/blob/main/README.md"
    },
    {
        team: "NbNative",
        project: "\u8BA9TiDB\u5728\u4E91\u4E0A\u667A\u80FD\u7684\u8BF4\u8BDD\u3002",
        intro: "\u89E3\u51B3\u5F53\u524DTiDB\u5728\u4E91\u4E0A\u4E91\u539F\u751F\u65B9\u5F0F\u8FD0\u7EF4\u7684\u5C40\u9650\u6027\uFF0C\u4E3ATiDB\u5728\u4E91\u4E0A\u63D0\u4F9B\u4E91\u539F\u751F\u573A\u666F\u4E0B\u667A\u80FD\u5316\u8FD0\u7EF4\u624B\u6BB5\uFF0C\u8BA9TiDB\u5728\u4E91\u4E0A\u667A\u80FD\u7684\u8BF4\u8BDD\u3002",
        rfc: "https://github.com/NbNative/RFC"
    },
    {
        team: "OneLastCode",
        project: "Incremental Analyze Table",
        intro: "We will cache the result of analyze request in TiKV node to avoid" + " calculating again next time.",
        rfc: "https://github.com/tikv/rfcs/pull/83"
    },
    {
        team: "FR",
        project: "TiExec",
        intro: "TiExec \u4F1A\u5C1D\u8BD5\u7ED9\u901A\u8FC7\u6B64\u5DE5\u5177\u8FD0\u884C\u7684\u7A0B\u5E8F\u505A\u4E00\u4E9B\u6027\u80FD\u4F18\u5316\uFF0C\u5728\u67D0\u4E9B\u573A\u666F\u4E0B\u4F1A\u5E26\u6765\u76F4\u63A5\u7684\u6027\u80FD\u63D0\u5347\uFF0C\u5982\u5728 TiDB \u7684\u67D0 OLTP" + " \u573A\u666F\u5BF9\u90E8\u5206\u7EC4\u4EF6\u8FDB\u884C\u4F18\u5316\u4E4B\u540E\u7684\u521D\u6B65\u6D4B\u8BD5\u663E\u793A\u80FD\u5E26\u6765\u7EA6 6-11% \u7684\u6574\u4F53\u6027\u80FD\u63D0\u5347",
        rfc: "https://github.com/hnes/tiexec/blob/main/RFC.md"
    },
    {
        team: "Ti2Sky",
        project: "TiTravel",
        intro: "\u6269\u5C55TiDB\u80FD\u529B\uFF0C\u5B9E\u73B0\u5BF9\u8D1F\u8F7D\u7684\u4E00\u952E\u5F55\u5236\u4E0E\u56DE\u653E\uFF0C\u4ECE\u800C\u5E2E\u52A9\u7528\u6237\u4FBF\u6377\u5730\u8FDB\u884C\u573A\u666F\u4EFF\u771F\u548C\u538B\u529B\u6D4B\u8BD5",
        rfc: "https://github.com/ti2sky/RFC"
    }, 
];

// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/leaderboard.styled.js
function leaderboard_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function leaderboard_styled_templateObject() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  // horizontally center\n  margin: 0 auto;\n"
    ]);
    leaderboard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject1() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  // table with 5 columns, rows are of alternating color, header is purple\n  font-size: 1rem;\n  width: 100%;\n  margin-bottom: 1rem;\n"
    ]);
    leaderboard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject2() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  // #674FF0 to #342878\n  background: linear-gradient(to right bottom, #674ff0, #342878);\n  color: #fff;\n  padding: 10px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    leaderboard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject3() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  background: ",
        ";\n"
    ]);
    leaderboard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject4() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  padding: 10px;\n  text-align: center;\n"
    ]);
    leaderboard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject5() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        ""
    ]);
    leaderboard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject6() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  padding: 10px;\n  text-align: center;\n"
    ]);
    leaderboard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject7() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    leaderboard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject8() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  background: #211a4b;\n  border-radius: 1rem;\n  border: none;\n\n  label {\n    line-height: 1.65rem;\n    height: 1.6rem;\n    padding-left: 8px;\n    padding-right: 8px;\n    background: #211a4b;\n    border: none !important;\n    color: #a9a0d9;\n  }\n\n  label:first-child {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  label:last-child {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n\n  .ant-radio-button-wrapper-checked {\n    border-radius: 1rem;\n    background: #6b6290 !important;\n  }\n\n  .ant-radio-button-wrapper:not(:first-child)::before {\n    display: none;\n  }\n"
    ]);
    leaderboard_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function leaderboard_styled_templateObject9() {
    var data = leaderboard_styled_taggedTemplateLiteral([
        "\n  color: #84fcfc;\n  text-decoration: none;\n\n  &:hover {\n    color: #674ff0;\n  }\n"
    ]);
    leaderboard_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var Leaderboard = styled_components_browser_esm/* default.div */.ZP.div(leaderboard_styled_templateObject(), function(props) {
    return props.sm ? "100%" : 10 * columnWidth + "vw";
});
var leaderboard_styled_Table = styled_components_browser_esm/* default.table */.ZP.table(leaderboard_styled_templateObject1());
var TableHeadRow = styled_components_browser_esm/* default.tr */.ZP.tr(leaderboard_styled_templateObject2());
var TableRow = styled_components_browser_esm/* default.tr */.ZP.tr(leaderboard_styled_templateObject3(), function(props) {
    return props.index % 2 === 0 ? "#303038" : "#25242C";
});
var leaderboard_styled_TableCell = styled_components_browser_esm/* default.td */.ZP.td(leaderboard_styled_templateObject4());
var TableHead = styled_components_browser_esm/* default.thead */.ZP.thead(leaderboard_styled_templateObject5());
var TableHeadCell = styled_components_browser_esm/* default.th */.ZP.th(leaderboard_styled_templateObject6());
var TableBody = styled_components_browser_esm/* default.tbody */.ZP.tbody(leaderboard_styled_templateObject7());
var ColumnSwitch = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default.Group */.ZP.Group)(leaderboard_styled_templateObject8());
var ExpandButton = styled_components_browser_esm/* default.a */.ZP.a(leaderboard_styled_templateObject9());

;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/prize-1.svg
var prize_1_defs, prize_1_g;
function prize_1_extends() { prize_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return prize_1_extends.apply(this, arguments); }

var SvgPrize1 = function SvgPrize1(props) {
  return /*#__PURE__*/react.createElement("svg", prize_1_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), prize_1_defs || (prize_1_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "prize-1_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#bfa244"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#605122"
  })))), prize_1_g || (prize_1_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7829"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19244",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-1_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19245",
    d: "m12.844 28.281-.089-.038-9.9-4.189V3.118h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.575H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19247",
    d: "M10.662 10.016V7.929h3.9v11.792h-2.331v-9.705Z",
    fill: "#fff"
  }))));
};
/* harmony default export */ var prize_1 = (SvgPrize1);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/prize-2.svg
var prize_2_defs, prize_2_g;
function prize_2_extends() { prize_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return prize_2_extends.apply(this, arguments); }

var SvgPrize2 = function SvgPrize2(props) {
  return /*#__PURE__*/react.createElement("svg", prize_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), prize_2_defs || (prize_2_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "prize-2_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })))), prize_2_g || (prize_2_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7830"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19250",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-2_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19251",
    d: "m12.844 28.281-.089-.038-9.9-4.189V3.118h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.575H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19256",
    d: "M9.989 17.424q1.553-1.294 2.475-2.16a10.01 10.01 0 0 0 1.537-1.8 3.358 3.358 0 0 0 .619-1.847 1.971 1.971 0 0 0-.388-1.294 1.465 1.465 0 0 0-1.202-.474 1.507 1.507 0 0 0-1.245.542 2.362 2.362 0 0 0-.453 1.48h-2.2a3.991 3.991 0 0 1 1.157-2.944 3.942 3.942 0 0 1 2.774-1 3.85 3.85 0 0 1 2.831.979 3.472 3.472 0 0 1 .987 2.58 4.664 4.664 0 0 1-.679 2.41 9.538 9.538 0 0 1-1.553 2q-.875.853-2.282 2.045h4.772v1.877h-7.99v-1.683Z",
    fill: "#fff"
  }))));
};
/* harmony default export */ var prize_2 = (SvgPrize2);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/prize-3.svg
var prize_3_defs, prize_3_g;
function prize_3_extends() { prize_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return prize_3_extends.apply(this, arguments); }

var SvgPrize3 = function SvgPrize3(props) {
  return /*#__PURE__*/react.createElement("svg", prize_3_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), prize_3_defs || (prize_3_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "prize-3_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#aa8952"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#554529"
  })))), prize_3_g || (prize_3_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u7EC4 7831"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19253",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-3_svg__a)"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19254",
    d: "m12.844 28.341-.089-.038-9.9-4.189V3.178h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.635H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19257",
    d: "M9.294 11.31a3.3 3.3 0 0 1 1.14-2.5 4.22 4.22 0 0 1 2.79-.882 4.553 4.553 0 0 1 2.022.412 2.968 2.968 0 0 1 1.27 1.116 3 3 0 0 1 .428 1.595 2.8 2.8 0 0 1-.526 1.723 2.576 2.576 0 0 1-1.254.946v.065a2.719 2.719 0 0 1 1.465 1.035 3.232 3.232 0 0 1 .526 1.909 3.363 3.363 0 0 1-.445 1.731 3.027 3.027 0 0 1-1.306 1.188 4.641 4.641 0 0 1-2.083.428 4.607 4.607 0 0 1-2.976-.922 3.448 3.448 0 0 1-1.213-2.717h2.2a1.762 1.762 0 0 0 .542 1.27 1.966 1.966 0 0 0 1.4.477 1.683 1.683 0 0 0 1.27-.461 1.641 1.641 0 0 0 .445-1.189 1.563 1.563 0 0 0-.615-1.391 3.429 3.429 0 0 0-1.91-.42h-.469v-1.858h.469q2.3 0 2.3-1.537a1.416 1.416 0 0 0-.412-1.084 1.671 1.671 0 0 0-1.189-.388 1.586 1.586 0 0 0-1.176.409 1.667 1.667 0 0 0-.477 1.043Z",
    fill: "#fff"
  }))));
};
/* harmony default export */ var prize_3 = (SvgPrize3);
;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/leaderboard.component.js







var mapPrizeLogo = function(prize) {
    switch(prize){
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(prize_1, {});
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(prize_2, {});
        case 3:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(prize_3, {});
        default:
            return prize;
    }
};
var leaderboard_component_Leaderboard = function(param) {
    var data = param.data, sm = param.sm;
    var LIMIT = 20;
    var isShowingAll = data.length <= LIMIT;
    var ref = (0,react.useState)(LIMIT), limit = ref[0], setLimit = ref[1];
    data = data.sort(function(a, b) {
        return b.score - a.score;
    });
    var switchOptions = [
        {
            label: "\u56E2\u961F",
            value: "teamName"
        },
        {
            label: "\u9879\u76EE",
            value: "projectName"
        }, 
    ];
    var expandOrCollapse = function() {
        if (limit === LIMIT) {
            setLimit(data.length);
        } else {
            setLimit(LIMIT);
        }
    };
    var ref1 = (0,react.useState)("teamName"), activeColumn = ref1[0], setActiveColumn = ref1[1];
    var onSwitchChange = function(e) {
        return setActiveColumn(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Leaderboard, {
        sm: sm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(leaderboard_styled_Table, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHeadRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeadCell, {
                                    children: "\u6392\u540D"
                                }),
                                sm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHeadCell, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnSwitch, {
                                            options: switchOptions,
                                            onChange: onSwitchChange,
                                            optionType: "button",
                                            buttonStyle: "solid",
                                            value: activeColumn
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeadCell, {
                                            children: "\u56E2\u961F\u540D\u79F0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeadCell, {
                                            children: "\u9879\u76EE\u540D\u79F0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeadCell, {
                                    children: "\u603B\u79EF\u5206"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                        children: data.slice(0, limit).map(function(row, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow, {
                                index: index,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_styled_TableCell, {
                                        children: mapPrizeLogo(index + 1)
                                    }),
                                    sm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_styled_TableCell, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                            fontSize: "16px",
                                            href: row[activeColumn.replace("Name", "Url")],
                                            children: row[activeColumn]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_styled_TableCell, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                    fontSize: "16px",
                                                    href: row.teamUrl,
                                                    children: row.teamName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_styled_TableCell, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                    fontSize: "16px",
                                                    href: row.projectUrl,
                                                    children: row.projectName
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_styled_TableCell, {
                                        children: row.score
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            !isShowingAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButton, {
                onClick: expandOrCollapse,
                children: limit >= data.length ? "\u6536\u8D77" : "\u67E5\u770B\u66F4\u591A"
            })
        ]
    });
};
/* harmony default export */ var leaderboard_component = (leaderboard_component_Leaderboard);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/leaderboard/index.js

/* harmony default export */ var leaderboard = (leaderboard_component);

;// CONCATENATED MODULE: ./src/pages/events/hackathon2021/index.page.js














var index_page_SectionTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitleBackground, {}),
            children
        ]
    });
};
var index_page_JudgeCard = function(param) {
    var name = param.name, desc = param.desc, src = param.src, detail = param.detail, sm = param.sm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JudgeCard, {
        src: src,
        sm: sm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeCardOverlay, {
                sm: sm,
                children: detail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JudgeCardContent, {
                sm: sm,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeCardName, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JudgeCardDescription, {
                        sm: sm,
                        children: desc
                    })
                ]
            })
        ]
    });
};
var index_page_NewsCard = function(param) {
    var title = param.title, src = param.src, sm = param.sm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCard, {
        src: src,
        sm: sm,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardContent, {
            sm: sm,
            children: [
                " ",
                title,
                " "
            ]
        })
    });
};
var index_page_WinnerCard = function(param) {
    var github = param.github, intro = param.intro, video = param.video, name = param.name, prize = param.prize, rfc = param.rfc, src = param.src, sm = param.sm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WinnerCard, {
                    src: src,
                    sm: sm,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WinnerCardContent, {
                            sm: sm,
                            children: [
                                prize,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WinnerCardOverlay, {
                            className: "winner-card-overlay",
                            children: intro
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WinnerRow, {
                justify: "center",
                gutter: 16,
                children: [
                    rfc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        border: true,
                        href: rfc,
                        children: "RFC"
                    }),
                    github && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        border: true,
                        href: github,
                        children: "Github Repo"
                    }),
                    video && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        border: true,
                        href: video,
                        children: "\u89C6\u9891\u56DE\u653E"
                    })
                ]
            })
        ]
    });
};
var splitCarousel = function(data, size) {
    // split data into groups of 3
    return lodash_default().chunk(data, size);
};
var index_page_BannerNavButtonsGroup = function(param) {
    var isSmallScreen = param.isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerNavButtonsGroup, {
        isSmallScreen: isSmallScreen
    });
};
var Page = function(param) {
    var data1 = param.data;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), QROverlay = ref[0], setQROverlay = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: seo.title,
                description: seo.description,
                keyword: seo.keywords
            }),
            QROverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerQRCodeOverlay, {
                onClick: function() {
                    return setQROverlay(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerQRCodeContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerQRCodeImage, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerQRCodeText, {
                            children: "\u62A5\u540D\u540E\u6DFB\u52A0\u5C0F\u52A9\u624B\u8FDB\u7FA4\u5427\uFF01"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                                isSmallScreen: isSmallScreen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContent, {
                                    isSmallScreen: isSmallScreen,
                                    children: [
                                        isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitleMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerButtonsGroup, {
                                            isSmallScreen: isSmallScreen,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerButton, {
                                                children: "\u62A5\u540D\u622A\u6B62"
                                            })
                                        }),
                                        !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_BannerNavButtonsGroup, {})
                                    ]
                                })
                            }),
                            isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_BannerNavButtonsGroup, {
                                isSmallScreen: isSmallScreen
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        leftAlign: true,
                        id: "intro",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u5927\u8D5B\u56DE\u987E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "\u4E3B\u9898\u4E3A\u300CExplore the Sky\u300D\u7684 TiDB Hackathon 2021 \u5B8C\u7F8E\u6536\u5B98\uFF01\u4ECA\u5E74\u5DF2\u7ECF\u662F TiDB Hackathon \u7B2C\u4E94\u5C4A\u8D5B\u4E8B\uFF0C\u53C2\u8D5B\u89C4\u6A21\u521B\u5386\u5C4A\u4E4B\u6700\uFF0C\u5171\u6709 279\u4EBA \uFF0C64 \u652F\u961F\u4F0D\u53C2\u8D5B\uFF0C\u6709\u6765\u81EA\u817E\u8BAF\u3001\u534E\u4E3A\u3001\u7F51\u6613\u3001\u7F8E\u56E2\u3001\u5B57\u8282\u3001\u4EAC\u4E1C\u3001\u6EF4\u6EF4\u7B49\u4F01\u4E1A\u7684\u4E0A\u73ED\u65CF\uFF0C\u4E5F\u6709\u6765\u81EA\u5317\u5927\u3001\u5317\u90AE\u3001\u4E2D\u79D1\u9662\u3001\u4E0A\u6D77\u4EA4\u5927\u3001RMIT \u7B49\u9AD8\u6821\u7684\u5B66\u751F\u3002"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "\u5728\u4E24\u5929\u4E00\u591C\u7684 Hacking Time \u4E2D\uFF0C\u56F4\u7ED5\u7740\u5185\u6838\u3001\u5DE5\u5177\u3001\u751F\u6001\u3001\u300C\u221E\u300D\u56DB\u5927\u8D5B\u9053\uFF0C\u9009\u624B\u4EEC\u62FF\u51FA\u4E86\u4F17\u591A\u4EE4\u8BC4\u59D4\u60CA\u8273\u7684\u9879\u76EE\u3002\u5728 TiDB \u5185\u6838\u65B9\u5411\u505A\u51FA\u4E0D\u5C11 hardcore \u3001\u5927\u5E45\u63D0\u5347\u6027\u80FD\u7684\u521B\u65B0\u9879\u76EE\uFF0C\u5728\u5DE5\u5177\u65B9\u5411\u5BF9 TiDB \u7684\u53EF\u89C2\u6D4B\u6027\u53CA\u8BCA\u65AD\u6613\u7528\u6027\u505A\u51FA\u4E86\u5927\u5E45\u4F18\u5316\uFF0C\u5728\u751F\u6001\u6269\u5C55\u65B9\u5411\u767E\u82B1\u9F50\u653E\uFF0C\u51FA\u73B0\u4E86\u8BED\u6CD5\u5B8C\u5907\u7684\u5206\u5E03\u5F0F\u56FE\u6570\u636E\u5E93\uFF0C\u7ED9 TiDB \u6253\u901A\u4E86\u5165\u6E56\u7684\u9AD8\u901F\u901A\u9053\uFF0C\u5F88\u591A\u9879\u76EE\u5176\u5B9E\u5DF2\u7ECF\u5728 TiDB \u7684 Roadmap \u91CC\uFF0C\u5E76\u5DF2\u7ECF\u5177\u5907\u843D\u5730\u7684\u6210\u719F\u5EA6\u3002\u6700\u7EC8\uFF0C\u6709 10 \u652F\u961F\u4F0D\u74DC\u5206\u4E86\u603B\u8BA1 40\u4E07\u5143\u7684\u73B0\u91D1\u5956\uFF0C\u53E6\u6709 10 \u652F\u961F\u4F0D\u5206\u83B7\u65E0\u9650\u521B\u610F\u5956\u3001\u6821\u56ED\u56E2\u961F\u5956\u3001\u7528\u6237\u4E4B\u9009\u5956\u3001\u6700\u4F73\u5E02\u573A\u6F5C\u529B\u5956\u3001\u4E91\u4E0A\u5E94\u7528\u5956\u3001\u79EF\u5206\u6311\u6218\u5956\u3001\u6280\u672F\u6F5C\u529B\u5956\u3001\u6700\u4F73\u4EBA\u6C14\u5956\u3002"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u4E3B\u9898\u8D5B\u9053"
                            }),
                            lodash_default().chunk(groupsData, isSmallScreen ? 2 : 4).map(function(data, chunkId) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: data.map(function(item, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderCell, {
                                                    isSmallScreen: isSmallScreen,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHeaderCellContent, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderIcon, {
                                                                src: getImage("group-icon-".concat(chunkId * 2 + idx + 1, ".svg"))
                                                            })
                                                        ]
                                                    })
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: data.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell, {
                                                    isSmallScreen: isSmallScreen,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCellContent, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCellContentInner, {
                                                            children: item.desc
                                                        })
                                                    })
                                                });
                                            })
                                        })
                                    ]
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u83B7\u5956\u9879\u76EE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                justify: "space-around",
                                children: [
                                    winners.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            onClick: function() {
                                                return (0,link_utils.handleRedirect)(router, item.url);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_WinnerCard, {
                                                name: item.name,
                                                prize: item.prize,
                                                src: getImage("winner-".concat(item.name, ".jpg")),
                                                sm: isSmallScreen,
                                                intro: item.intro,
                                                github: item.github,
                                                rfc: item.rfc,
                                                video: item.video
                                            })
                                        });
                                    }),
                                    isSmallScreen || winners.length % 3 !== 0 && lodash_default().range(3 - winners.length % 3).map(function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyNewsCard, {
                                            sm: isSmallScreen
                                        });
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u5165\u56F4\u9879\u76EE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                justify: "space-around",
                                children: [
                                    finalists.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            onClick: function() {
                                                return (0,link_utils.handleRedirect)(router, item.url);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalistCard, {
                                                    sm: isSmallScreen,
                                                    children: item.intro
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalistRow, {
                                                    justify: "start",
                                                    sm: isSmallScreen,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "\u56E2\u961F\u540D\u79F0\uFF1A",
                                                            item.team
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinalistRow, {
                                                    justify: "space-between",
                                                    sm: isSmallScreen,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                "\u9879\u76EE\u540D\u79F0\uFF1A",
                                                                item.project
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                            href: item.rfc,
                                                            children: " RFC "
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }),
                                    isSmallScreen || finalists.length % 3 !== 0 && lodash_default().range(3 - finalists.length % 3).map(function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyNewsCard, {
                                            sm: isSmallScreen
                                        });
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        id: "judges",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u8BC4\u59D4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JudgesLabel, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlowLabel, {
                                        children: "\u8BC4\u59D4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                justify: "space-between",
                                children: [
                                    judgesData.map(function(judge) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_JudgeCard, {
                                                name: judge.name,
                                                desc: judge.desc,
                                                src: getImage("judges/".concat(encodeURIComponent(judge.name), ".png")),
                                                detail: judge.detail,
                                                sm: isSmallScreen
                                            })
                                        });
                                    }),
                                    judgesData.length % (isSmallScreen ? 2 : 5) !== 0 && lodash_default().range((isSmallScreen ? 2 : 5) - judgesData.length % (isSmallScreen ? 2 : 5)).map(function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyJudgeCard, {
                                            sm: isSmallScreen
                                        });
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFooter, {
                                children: "\u8BC4\u59D4\u6309\u59D3\u540D\u5B57\u6BCD\u6392\u5E8F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        id: "scores",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u79EF\u5206\u699C"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard, {
                                sm: isSmallScreen,
                                data: data1.leaderboard
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        id: "news",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u4E13\u9898\u62A5\u9053"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                justify: "space-around",
                                children: [
                                    data1.news.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            onClick: function() {
                                                return (0,link_utils.handleRedirect)(router, item.url);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_NewsCard, {
                                                name: item.title,
                                                src: utils/* common.getStrapiImgProps */.y0.getStrapiImgProps(item.preview).src,
                                                sm: isSmallScreen,
                                                title: item.title
                                            })
                                        });
                                    }),
                                    isSmallScreen || data1.news.length % 3 !== 0 && lodash_default().range(3 - data1.news.length % 3).map(function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyNewsCard, {
                                            sm: isSmallScreen
                                        });
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PartnerSection, {
                        id: "partners",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u5408\u4F5C\u4F19\u4F34"
                            }),
                            "\u9EC4\u91D1\u8D5E\u52A9",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: lodash_default().range(1, 4).map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("gold-sponsor-".concat(i, ".png")),
                                        height: isSmallScreen ? 60 : 80,
                                        alt: "gold-sponsor-".concat(i, ".png")
                                    });
                                })
                            }),
                            "\u767D\u94F6\u8D5E\u52A9",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: lodash_default().range(1, 4).map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("silver-sponsor-".concat(i, ".png")),
                                        height: isSmallScreen ? 60 : 80,
                                        alt: "silver-sponsor-".concat(i, ".png")
                                    });
                                })
                            }),
                            "\u4E91\u8D44\u6E90\u8D5E\u52A9/\u4E91\u6280\u672F\u670D\u52A1\u652F\u6301",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: lodash_default().range(1, 5).map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("cloud-sponsor-".concat(i, ".png")),
                                        height: isSmallScreen ? 60 : 80,
                                        alt: "cloud-sponsor-".concat(i, ".png")
                                    });
                                })
                            }),
                            "\u534F\u4F5C\u65B9",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: lodash_default().range(1, 3).map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("corecognizer-logo-".concat(i, ".png")),
                                        height: isSmallScreen ? 60 : 80,
                                        alt: "corecognizer-logo-".concat(i, ".png")
                                    });
                                })
                            }),
                            "\u5A92\u4F53/\u5408\u4F5C\u793E\u533A",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                children: lodash_default().range(17, 0, -1).map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("partner-logo-".concat(i, ".png")),
                                        height: isSmallScreen ? 60 : 80,
                                        alt: "partner-logo-".concat(i, ".png")
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_SectionTitle, {
                                children: "\u5F80\u671F\u56DE\u987E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                                children: splitCarousel(carouselData, isSmallScreen ? 1 : 3).map(function(group) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselInner, {
                                        children: group.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselContent, {
                                                width: 100 / splitCarousel(carouselData, isSmallScreen ? 1 : 3)[0].length + "%",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: item.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_image/* default */.Z, {
                                                            preview: false,
                                                            src: item.img
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselDescription, {
                                                        children: item.desc
                                                    })
                                                ]
                                            });
                                        })
                                    });
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,5180,4458,8664,9774,2888,179], function() { return __webpack_exec__(15597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);